import { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { useFilters } from "../hooks/Funcionarios_cadastro/filters"; //
import { processError } from "../../../../common/utils/base_error";
import { Documento } from "../../domain/models/documento";
import { DocumentoEntregue } from "../../domain/models/documento_entregue";
import { Dependente } from "../../domain/models/dependente";
import { Evento } from "../../domain/models/evento";
import { Ferias } from "../../domain/models/ferias";
import { Afastamento } from "../../domain/models/afastamento";
import { FuncionarioTreinamento } from "../../domain/models/funcionario_treinamento";
import { AvaliacaoHabilidade } from "../../domain/models/avaliacao_habilidade";
import { HabilidadeItem } from "../../domain/models/habilidade_item";
import { ControlePatrimonio } from "../../domain/models/controle_patrimonio";
import { Funcionario } from "../../domain/models/funcionario";
import { CentroCustoSecundario } from "../../domain/models/centro_custo_secundario";
import {
  FuncionarioForm,
  FuncionarioSchema,
} from "../schemas/Funcionarios_cadastro/funcionario_schema";
import { CentroCustoSecundarioForm } from "../schemas/Funcionarios_cadastro/centro_custo_secundario";
import { DependenteForm } from "../schemas/Funcionarios_cadastro/dependente_schema";
import { EventoForm } from "../schemas/Funcionarios_cadastro/evento_schema";
import { FeriasForm } from "../schemas/Funcionarios_cadastro/ferias_schema";
import { AfastamentoForm } from "../schemas/Funcionarios_cadastro/afastamento_schema";
import { DocumentoForm } from "../schemas/Funcionarios_cadastro/documento_schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { TreinamentoForm } from "../schemas/Funcionarios_cadastro/treinamento_schema";
import { AvaliarTreinamentoForm } from "../schemas/Funcionarios_cadastro/avaliar_treinamento_schema";
import { HabilidadeItemForm } from "../schemas/Funcionarios_cadastro/habilidade_item_schema";
import { AvaliacaoHabilidadeForm } from "../schemas/Funcionarios_cadastro/habilidade_schema";
import { ControlePatrimonioForm } from "../schemas/Funcionarios_cadastro/controle_patrimonio_schema";
import { RelatorioFuncionarioTreinamentoForm } from "../schemas/Funcionarios_cadastro/relatorio_funcionario_treinamento_schema";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import { useBackOrNavigate } from "../../../../common/utils/navigateUtils";
import { LogTipoTabela } from "../../../../common/utils/log_tabela_tipo";
import { useChangeHistory } from "../../../../common/hooks/use_change_history";
import { usePagination } from "../hooks/Funcionarios_cadastro/pagination"; //
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { useCachedDataLoader } from "../../../../common/hooks/use_cached_data_loader";
import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";
import { useCentroCustoDrawer } from "../../../../common/components/drawers_api/drawers/centro_custo_drawer";
import { useMotivoDemissaoDrawer } from "../../../../common/components/drawers_api/drawers/motivo_demissao_drawer";
import { TelasIds } from "../../../../common/utils/tela_ids";
import { BiometriaFacial } from "../../domain/models/biometria_facial";
import { BiometriaFacialForm } from "../schemas/Funcionarios_cadastro/biometria_facial_schema";
import { TermoEpi } from "../../../gestaoEpi/domain/models/termo_epi";
import { TermoBiometriaForm } from "../schemas/Funcionarios_cadastro/termo_biometria_schema";
import { GryfoAudit } from "../../../gestaoEpi/domain/models/gryfo_audit";
import { CertificadoFuncionarioTreinamentoForm } from "../schemas/Funcionarios_cadastro/certificado_funcionario_treinamento_schema";
import { JobStatusResponse } from "../../../../common/domain/models/job_status_response";

import CommonConstants from "../../../../common/constants";
import dayjs from "dayjs";

/**
 * useFuncionariosCadastroViewModel
 */

export const useFuncionariosCadastroViewModel = () => {
  const {
    commons: {
      getCentroCustoDropDownUseCase,
      getCargosDropDownUseCase,
      getFuncionariosDropDownUseCase,
      getAllLogAlteracaoUseCase,
      getAllLogAlteracaoByParentUseCase,
      getJobStatusUseCase,
    },
    reports: {
      getReportFuncionarioTreinamentoUseCase,
      getReportAvaliacaoHabilidadeUseCase,
      getReportCadastroFuncionarioUseCase,
    },
    rh: {
      getItensVerbaDropDownUseCase,
      getEquipamentosDropDownUseCase,
      getTreinamentosDropDownUseCase,
      getMotivosAfastamentoDropDownUseCase,
      getMotivosDemissaoDropDownUseCase,
      getHabilidadesDropDownUseCase,
      getFuncionarioAssinaturaDropDownUseCase,
      getCepUseCase,
      getDocumentosUseCase,
      getDocumentosEntreguesUseCase,
      getFuncionarioTreinamentosUseCase,
      getHabilidadesUseCase,
      getDependentesUseCase,
      getEventosUseCase,
      getFeriasUseCase,
      getAfastamentosUseCase,
      getHabilidadeItemsUseCase,
      getControlePatrimoniosUseCase,
      getFuncionarioByIdUseCase,
      getCentroCustoSecundariosUseCase,
      createFuncionarioUseCase,
      updateFuncionarioUseCase,
      createCentroCustoSecundarioUseCase,
      updateCentroCustoSecundarioUseCase,
      deleteCentroCustoSecundarioUseCase,
      createDependenteUseCase,
      updateDependenteUseCase,
      deleteDependenteUseCase,
      createEventoUseCase,
      updateEventoUseCase,
      deleteEventoUseCase,
      createFeriasUseCase,
      updateFeriasUseCase,
      deleteFeriasUseCase,
      createAfastamentoUseCase,
      updateAfastamentoUseCase,
      deleteAfastamentoUseCase,
      createDocumentoUseCase,
      updateDocumentoUseCase,
      deleteDocumentoUseCase,
      deleteAllDocumentosUseCase,
      createFuncionarioTreinamentoUseCase,
      updateFuncionarioTreinamentoUseCase,
      deleteFuncionarioTreinamentoUseCase,
      deleteFuncionarioTreinamentosLoteUseCase,
      avaliarTreinamentoUseCase,
      createAvaliacaoHabilidadeUseCase,
      updateAvaliacaoHabilidadeUseCase,
      deleteAvaliacaoHabilidadeUseCase,
      createAvaliacaoHabilidadeItemUseCase,
      updateAvaliacaoHabilidadeItemUseCase,
      deleteAvaliacaoHabilidadeItemUseCase,
      createControlePatrimonioUseCase,
      updateControlePatrimonioUseCase,
      deleteControlePatrimonioUseCase,
      getFuncionarioAllDocumentosUseCase,
      createMotivoDemissaoUseCase,
      deleteFuncionarioUseCase,
      downloadFuncionarioDocumentoByIdUseCase,
      downloadControlePatrimonioByIdUseCase,
      getFuncionarioImageByIdUseCase,
      deleteFuncionarioImageByIdUseCase,
      createBiometriaFacialUseCase,
      createBiometriaFacialFuncionarioUseCase,
      getBiometriaFacialUseCase,
      inativarBiometriaFacialUseCase,
      getBiometriaFacialVisualizarUseCase,
      createTermoBiometriaUseCase,
      generateCertificateUseCase,
    },
    comercial: { createCentroCustoUseCase },
    gestaoEpi: { getAllTermoEPIUseCase, getBiometriaAuditoriaUseCase },
  } = useDependencyInjection();

  const location = useLocation();

  const {
    setPageSaving,
    setCustomLoading,
    pushErrorNotification,
    pushWarnNotification,
    pushInfoNotification,
  } = usePageLoader();

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [currentTab, setCurrentTab] = useState(1);
  const [idFuncionario, setIdFuncionario] = useState<number | undefined>(
    undefined,
  );

  const [jobId, setJobId] = useState<string>();

  const hookForm = useForm<FuncionarioForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    disabled: loading,
    resolver: zodResolver(FuncionarioSchema),
  });

  const backOrNavigate = useBackOrNavigate();

  const filters = useFilters();
  const pagination = usePagination();

  const [funcionario, setFuncionario] = useState<
    Funcionario | null | undefined
  >();

  const [fileUpload, setFileUpload] = useState<string>();

  const [selectedCentroCustoSecundario, setSelectedCentroCustoSecundario] =
    useState<CentroCustoSecundario>();
  const [selectedDependente, setSelectedDependente] = useState<Dependente>();
  const [selectedEvento, setSelectedEvento] = useState<Evento>();
  const [selectedFerias, setSelectedFerias] = useState<Ferias>();
  const [selectedAfastamento, setSelectedAfastamento] = useState<Afastamento>();

  const [selectedFuncionarioTreinamento, setSelectedFuncionarioTreinamento] =
    useState<FuncionarioTreinamento>();
  const [
    selectedIdFuncionarioTreinamentosLote,
    setSelectedIdFuncionarioTreinamentosLote,
  ] = useState<number[]>();
  const [selectedDocumento, setSelectedDocumento] = useState<Documento>();
  const [selectedHabilidade, setSelectedHabilidade] =
    useState<AvaliacaoHabilidade>();

  const [selectedHabilidadeItem, setSelectedHabilidadeItem] =
    useState<HabilidadeItem>();
  const [selectedHabilidadeItems, setSelectedHabilidadeItems] =
    useState<HabilidadeItem[]>();

  const [selectedControlePatrimonio, setSelectedControlePatrimonio] =
    useState<ControlePatrimonio>();

  const [selectedBiometriaFacial, setSelectedBiometriaFacial] =
    useState<BiometriaFacial>();

  const [
    openCadastroCentroCustoSecundarioModal,
    setOpenCadastroCentroCustoSecundarioModal,
  ] = useState(false);
  const [openCadastroDependenteModal, setOpenCadastroDependenteModal] =
    useState(false);
  const [openCadastroEventoModal, setOpenCadastroEventoModal] = useState(false);
  const [openCadastroFeriasModal, setOpenCadastroFeriasModal] = useState(false);
  const [openCadastroAfastamentoModal, setOpenCadastroAfastamentoModal] = useState(false);
  const [openJobWaiterModel, setOpenJobWaiterModel] = useState(false);

  const [
    openDeletarCentroCustoSecundarioModal,
    setOpenDeletarCentroCustoSecundarioModal,
  ] = useState(false);
  const [openInativarBiometriaModal, setOpenInativarBiometriaModal] =
    useState(false);
  const [openDeletarDependenteModal, setOpenDeletarDependenteModal] =
    useState(false);
  const [openDeletarEventoModal, setOpenDeletarEventoModal] = useState(false);
  const [openDeletarFeriasModal, setOpenDeletarFeriasModal] = useState(false);
  const [openDeletarAfastamentoModal, setOpenDeletarAfastamentoModal] =
    useState(false);

  const [openCadastroDocumentoModal, setOpenCadastroDocumentoModal] =
    useState(false);
  const [openDeletarDocumentoModal, setOpenDeletarDocumentoModal] =
    useState(false);
  const [openDeletarAllDocumentosModal, setOpenDeletarAllDocumentosModal] =
    useState(false);

  const [
    openCadastroFuncionarioTreinamentoModal,
    setOpenCadastroFuncionarioTreinamentoModal,
  ] = useState(false);
  const [
    openAvaliarFuncionarioTreinamentoModal,
    setOpenAvaliarFuncionarioTreinamentoModal,
  ] = useState(false);
  const [
    openDeletarFuncionarioTreinamentoModal,
    setOpenDeletarFuncionarioTreinamentoModal,
  ] = useState(false);
  const [
    openDeletarFuncionarioTreinamentosLoteModal,
    setOpenDeletarFuncionarioTreinamentosLoteModal,
  ] = useState(false);
  const [
    openRelatorioFuncionarioTreinamentoModal,
    setOpenRelatorioFuncionarioTreinamentoModal,
  ] = useState(false);

  const [
    openCertificadoFuncionarioTreinamentoModal,
    setOpenCertificadoFuncionarioTreinamentoModal,
  ] = useState(false);

  const [openCadastroHabilidadeModal, setOpenCadastroHabilidadeModal] =
    useState(false);
  const [openDeletarHabilidadeModal, setOpenDeletarHabilidadeModal] =
    useState(false);

  const [openCadastroHabilidadeItemModal, setOpenCadastroHabilidadeItemModal] =
    useState(false);
  const [openDeletarHabilidadeItemModal, setOpenDeletarHabilidadeItemModal] =
    useState(false);

  const [
    openCadastroControlePatrimonioModal,
    setOpenCadastroControlePatrimonioModal,
  ] = useState(false);
  const [
    openDeletarControlePatrimonioModal,
    setOpenDeletarControlePatrimonioModal,
  ] = useState(false);

  const [
    openCadastroBiometriaFacialModal,
    setOpenCadastroBiometriaFacialModal,
  ] = useState(false);

  const [gryfoRequestId, setGryfoRequestId] = useState<string>("");

  const changeHistory = useChangeHistory({
    getAllLogAlteracaoByParentUseCase: getAllLogAlteracaoByParentUseCase,
    getAllLogAlteracaoUseCase: getAllLogAlteracaoUseCase,
    onSetError: (e) =>
      pushErrorNotification("Erro", [e], { isAutoFinish: true }),
  });

  const [reportViewerState, startReportViewerProcess] = useReportViewer();

  const [centroCustoDrawerState, startCentroCustoDrawer] =
    useCentroCustoDrawer();
  const [motivoDemissaoDrawerState, startMotivoDemissaoDrawer] =
    useMotivoDemissaoDrawer();

  /**
   * Informações Gerais estados
   */

  const [centroCustoSecundarios, setCentroCustoSecundarios] =
    useState<CentroCustoSecundario[]>();
  const [dependentes, setDependentes] = useState<Dependente[]>();
  const [eventos, setEventos] = useState<Evento[]>();
  const [ferias, setFerias] = useState<Ferias[]>();
  const [afastamentos, setAfastamentos] = useState<Afastamento[]>();

  /**
   * Documentos estados
   */

  const [documentos, setDocumentos] = useState<Documento[]>();
  const [documentosEntregues, setDocumentosEntregues] =
    useState<DocumentoEntregue[]>();

  /**
   * FuncionarioTreinamentos estados
   */

  const [funcionarioTreinamentos, setFuncionarioTreinamentos] =
    useState<FuncionarioTreinamento[]>();

  /**
   * Habilidades estados
   */

  const [habilidades, setHabilidades] = useState<AvaliacaoHabilidade[]>();

  /**
   * Controle de patrimonio estados
   */

  const [controlePatrimonios, setControlePatrimonios] =
    useState<ControlePatrimonio[]>();

  /**
   * Biometria Facial estados
   */
  const [biometriaFacial, setBiometriaFacial] = useState<BiometriaFacial[]>();

  /**
   * Termo Biometria
   */
  const [termoModal, setTermoModal] = useState<boolean>(false);
  const [selectedTermo, setSelectedTermo] = useState<TermoEpi>();
  const [termoEpiLista, setTermoEpiLista] = useState<TermoEpi[]>();
  const [deleteTermoModal, setDeleteTermoModal] = useState(false);
  const [selectedGryfoAudit, setSelectedGryfoAudit] = useState<GryfoAudit>();
  const [gryfoAuditOpen, setModalGryfoAudit] = useState<boolean>(false);
  const [modalImagemOpen, setModalImagemOpen] = useState<boolean>(false);
  const [imagemUrl, setImagemUrl] = useState<any>(null);

  /**
   * Estados computados
   */

  const isCreated = useMemo(() => {
    return idFuncionario !== undefined && idFuncionario !== null;
  }, [idFuncionario]);

  const status = useMemo(() => {
    const startToday = dayjs().startOf("day").utc().toDate();
    const endToday = dayjs().endOf("day").utc().toDate();

    if (funcionario === undefined || funcionario === null) return null;
    if (funcionario.dataDemissao) return 0; // DEMITIDO
    if (funcionario.inicioAvisoPrevio) {
      if (funcionario.fimAvisoPrevio) {
        if (dayjs(funcionario.fimAvisoPrevio).isAfter(startToday)) {
          return 2; // AVISO PRÉVIO ENCERRADO
        }
      }
      return 3; // AVISO PRÉVIO
    }
    if (afastamentos) {
      const afastamentoAtivo = afastamentos.find((a) => {
        if (a.dataInicio && a.dataTermino) {
          return (
            dayjs(a.dataInicio).isBefore(startToday) &&
            dayjs(a.dataTermino).isAfter(endToday)
          );
        }
        if (a.dataInicio) {
          return dayjs(a.dataInicio).isBefore(startToday);
        }
        return false;
      });

      if (afastamentoAtivo) {
        return 1; // AFASTADO
      }
    }
    return 4; // ATIVO
  }, [funcionario, afastamentos]);

  /**
   * Funcoes de carregamento
   */

  const loadFuncionario = useCallback(
    async (params?: { idFuncionario?: number }) => {
      try {
        const id = params?.idFuncionario ?? idFuncionario;

        if (!id) throw new Error("Falha ao carregar funcionario!");

        const funcionario =
          await getFuncionarioByIdUseCase.getFuncionarioById(id);

        if (!funcionario) throw new Error("Falha ao carregar funcionario!");

        if (funcionario && funcionario.hasProfileImage) {
          const userImageUrl =
            await getFuncionarioImageByIdUseCase.getFuncionarioImageById(
              funcionario.idFuncionario,
            );

          setFileUpload(userImageUrl);

          requestAnimationFrame(() => {
            const imageComponent = document.getElementById("funcionarioImagem");
            if (imageComponent !== null) {
              if (imageComponent instanceof HTMLImageElement) {
                imageComponent.src = userImageUrl;
              }
            }
          });
        }
        hookForm.setValue("nome", funcionario.nome);
        hookForm.setValue("dataAdmissao", funcionario.dataAdmissao);
        hookForm.setValue("idCentroCusto", funcionario.idCentroCusto ?? 0);
        hookForm.setValue("sexo", funcionario.sexo ?? "");
        hookForm.setValue("idCargo", funcionario.idCargo ?? 0);
        hookForm.setValue("dataNascimento", funcionario.dataNascimento);
        hookForm.setValue("regime", funcionario.regime);
        hookForm.setValue("setor", funcionario.setor);
        hookForm.setValue(
          "avaliarHabilidadesEm",
          funcionario.avaliarHabilidadesEm,
        );
        hookForm.setValue("descontoSindical", funcionario.descontoSindical);
        hookForm.setValue("filial", funcionario.filial);
        hookForm.setValue("email1", funcionario.email1);
        hookForm.setValue("email2", funcionario.email2);
        hookForm.setValue("matricula", funcionario.matricula);
        hookForm.setValue("telefoneMovel", funcionario.telefoneMovel);
        hookForm.setValue("telefoneFixo", funcionario.telefoneFixo);
        hookForm.setValue("horarioTrabalho", funcionario.horarioTrabalho);
        hookForm.setValue("horarioAlmoco", funcionario.horarioAlmoco);
        hookForm.setValue("nacionalidade", funcionario.nacionalidade);
        hookForm.setValue("naturalidade", funcionario.naturalidade);
        hookForm.setValue("estado", funcionario.estado);
        hookForm.setValue("cpf", funcionario.cpf);
        hookForm.setValue("numeroPis", funcionario.numeroPis);
        hookForm.setValue("estadoCivil", funcionario.estadoCivil);
        hookForm.setValue("salario", funcionario.salario);
        hookForm.setValue("periodo", funcionario.periodo);
        hookForm.setValue("experiencia", funcionario.experiencia);
        hookForm.setValue("prorrogarEm", funcionario.prorrogarEm);
        hookForm.setValue(
          "aprovadoExperiencia",
          funcionario.aprovadoExperiencia,
        );
        hookForm.setValue("escolaridade", funcionario.escolaridade);
        hookForm.setValue("cargaHorarioMensal", funcionario.cargaHorarioMensal);
        hookForm.setValue("valeTransporte", funcionario.valeTransporte);
        hookForm.setValue(
          "valorValeTransporte",
          funcionario.valorValeTransporte,
        );
        hookForm.setValue("ctps", funcionario.ctps);
        hookForm.setValue("ctpsSerie", funcionario.ctpsSerie);
        hookForm.setValue("ctpsEstado", funcionario.ctpsEstado);
        hookForm.setValue("ctpsDataEmissao", funcionario.ctpsDataEmissao);
        hookForm.setValue("rg", funcionario.rg);
        hookForm.setValue("rgDataExped", funcionario.rgDataExped);
        hookForm.setValue("rgOrgaoExped", funcionario.rgOrgaoExped);
        hookForm.setValue("rgEstado", funcionario.rgEstado);
        hookForm.setValue("tituloEleitor", funcionario.tituloEleitor);
        hookForm.setValue("tituloZona", funcionario.tituloZona);
        hookForm.setValue("tituloSecao", funcionario.tituloSecao);
        hookForm.setValue("reservista", funcionario.reservista);
        hookForm.setValue("nomeMae", funcionario.nomeMae);
        hookForm.setValue("nomePai", funcionario.nomePai);
        hookForm.setValue("conjugeNome", funcionario.conjugeNome);
        hookForm.setValue("conjugeRg", funcionario.conjugeRg);
        hookForm.setValue("conjugeCpf", funcionario.conjugeCpf);
        hookForm.setValue(
          "complementoCamisaInfo",
          funcionario.complementoCamisaInfo,
        );
        hookForm.setValue(
          "complementoCalcaInfo",
          funcionario.complementoCalcaInfo,
        );
        hookForm.setValue(
          "complementoCalcadoInfo",
          funcionario.complementoCalcadoInfo,
        );
        hookForm.setValue("enderecoCep", funcionario.enderecoCep);
        hookForm.setValue("enderecoCidade", funcionario.enderecoCidade);
        hookForm.setValue("enderecoEndereco", funcionario.enderecoEndereco);
        hookForm.setValue("enderecoNumero", funcionario.enderecoNumero);
        hookForm.setValue(
          "enderecoComplemento",
          funcionario.enderecoComplemento,
        );
        hookForm.setValue("enderecoBairro", funcionario.enderecoBairro);
        hookForm.setValue("enderecoEstado", funcionario.enderecoEstado);
        hookForm.setValue("enderecoPais", funcionario.enderecoPais);
        hookForm.setValue("bancTipoInfo", funcionario.bancTipoInfo);
        hookForm.setValue("bancBancoInfo", funcionario.bancBancoInfo);
        hookForm.setValue("bancAgenciaInfo", funcionario.bancAgenciaInfo);
        hookForm.setValue("bancContaInfo", funcionario.bancContaInfo);
        hookForm.setValue(
          "bancContaDigitoInfo",
          funcionario.bancContaDigitoInfo,
        );
        hookForm.setValue("bancOperacaoInfo", funcionario.bancOperacaoInfo);
        hookForm.setValue("bancPixInfo", funcionario.bancPixInfo);
        hookForm.setValue("observacaoGeral", funcionario.observacaoGeral);
        hookForm.setValue(
          "observacaoDocumento",
          funcionario.observacaoDocumento,
        );
        hookForm.setValue("demissaoData", funcionario.demissaoData);
        hookForm.setValue("demissaoIdDemissao", funcionario.idMotivoDemissao);
        hookForm.setValue("inicioAvisoPrevio", funcionario.inicioAvisoPrevio);
        hookForm.setValue("fimAvisoPrevio", funcionario.fimAvisoPrevio);
        hookForm.setValue(
          "horarioTrabalhoSegQui",
          funcionario.horarioTrabalhoSegQui,
        );
        hookForm.setValue("horarioTrabalhoSex", funcionario.horarioTrabalhoSex);

        setFuncionario({ ...funcionario });
      } catch (e: unknown) {
        setFuncionario(null);
        throw e;
      }
    },
    [
      idFuncionario,
      hookForm,
      getFuncionarioByIdUseCase,
      getFuncionarioImageByIdUseCase,
    ],
  );

  const loadBiometriaFacial = useCallback(
    async (params?: { idFuncionario?: number }) => {
      try {
        const id = params?.idFuncionario ?? idFuncionario;
        if (id) {
          await getBiometriaFacialUseCase.getBiometriaFacial(id);
          setBiometriaFacial(getBiometriaFacialUseCase.items);
        }
      } catch (e: unknown) {
        setBiometriaFacial([]);
        throw e;
      }
    },
    [getBiometriaFacialUseCase, idFuncionario],
  );
  const loadListaTermos = useCallback(async () => {
    try {
      await getAllTermoEPIUseCase.execute();
      setTermoEpiLista(getAllTermoEPIUseCase.items);
    } catch (e: unknown) {
      setTermoEpiLista(undefined);
      throw new Error("Falha ao buscar dados da pagina!");
    }
  }, [getAllTermoEPIUseCase]);

  const loadCentroCustoDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.centroCustoDropDown,
    loader: async () =>
      await getCentroCustoDropDownUseCase.getCentroCustoDropDown(),
    onSet: (dt) => useFilters.getState().setCentroCustoLista(dt),
    onError: (e) => {
      useFilters.getState().setCentroCustoLista([]);
      throw e;
    },
  });

  const loadTreinamentosDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.treinamentosDropDown,
    loader: async () =>
      await getTreinamentosDropDownUseCase.getTreinamentosDropDown(),
    onSet: (dt) => useFilters.getState().setTreinamentoLista(dt),
    onError: (e) => {
      useFilters.getState().setTreinamentoLista([]);
      throw e;
    },
  });

  const loadHabilidadesDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.habilidadesDropDown,
    loader: async () =>
      await getHabilidadesDropDownUseCase.getHabilidadesDropDown(),
    onSet: (dt) => useFilters.getState().setHabilidadesLista(dt),
    onError: (e) => {
      useFilters.getState().setHabilidadesLista([]);
      throw e;
    },
  });

  const loadFuncionariosDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.funcionariosDropDown,
    loader: async () =>
      await getFuncionariosDropDownUseCase.getFuncionariosDropDown(),
    onSet: (dt) => useFilters.getState().setFuncionarioLista(dt),
    onError: (e) => {
      useFilters.getState().setFuncionarioLista([]);
      throw e;
    },
  });

  const loadCargosDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.cargoDropDown,
    loader: async () => await getCargosDropDownUseCase.getCargosDropDown(),
    onSet: (dt) => useFilters.getState().setCargoLista(dt),
    onError: (e) => {
      useFilters.getState().setCargoLista([]);
      throw e;
    },
  });

  const loadItensVerbaDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.itensVerbaDropDown,
    loader: async () =>
      await getItensVerbaDropDownUseCase.getItensVerbaDropDown(),
    onSet: (dt) => useFilters.getState().setEventosItensVerbaLista(dt),
    onError: (e) => {
      useFilters.getState().setEventosItensVerbaLista([]);
      throw e;
    },
  });

  const loadEquipamentosDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.equipamentosDropDown,
    loader: async () =>
      await getEquipamentosDropDownUseCase.getEquipamentosDropDown(),
    onSet: (dt) => useFilters.getState().setEquipamentoLista(dt),
    onError: (e) => {
      useFilters.getState().setEquipamentoLista([]);
      throw e;
    },
  });

  const loadMotivosAfastamentoDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.motivoAfastamentoDropDown,
    loader: async () =>
      await getMotivosAfastamentoDropDownUseCase.getMotivosAfastamentoDropDown(),
    onSet: (dt) => useFilters.getState().setAfastamentoMotivosAfastamento(dt),
    onError: (e) => {
      useFilters.getState().setAfastamentoMotivosAfastamento([]);
      throw e;
    },
  });

  const loadMotivoDemissaoDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.motivoDemissaoDropDown,
    loader: async () =>
      await getMotivosDemissaoDropDownUseCase.getMotivosDemissaoDropDown(),
    onSet: (dt) =>
      useFilters.getState().setFuncionarioMotivosDemissaoDropDownLista(dt),
    onError: (e) => {
      useFilters.getState().setFuncionarioMotivosDemissaoDropDownLista([]);
      throw e;
    },
  });

  const loadFuncionarioAssinaturasDropDown = useCachedDataLoader({
    key: CommonConstants.cacheKey.funcionarioAssinaturasDropDown,
    loader: async () =>
      await getFuncionarioAssinaturaDropDownUseCase.getFuncionarioAssinaturaDropDown(),
    onSet: (dt) =>
      useFilters.getState().setFuncionarioAssinaturasDropDownLista(dt),
    onError: (e) => {
      useFilters.getState().setFuncionarioAssinaturasDropDownLista([]);
      throw e;
    },
  });

  const loadCentroCustoSecundarios = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.centroCustoSecundarios.page;
          const rowsPerPage =
            params?.rowsPerPage ??
            pagination.centroCustoSecundarios.rowsPerPage;

          await getCentroCustoSecundariosUseCase.getCentroCustoSecundarios(
            id,
            page,
            rowsPerPage,
          );

          setCentroCustoSecundarios(getCentroCustoSecundariosUseCase.items);

          usePagination
            .getState()
            .centroCustoSecundariosSetter.setRowsPerPage(
              getCentroCustoSecundariosUseCase.pageSize,
            );
          usePagination
            .getState()
            .centroCustoSecundariosSetter.setTotalItems(
              getCentroCustoSecundariosUseCase.totalItems,
            );
        }
      } catch (e: unknown) {
        setControlePatrimonios([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getCentroCustoSecundariosUseCase],
  );

  const loadDocumentos = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.documentos.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.documentos.rowsPerPage;

          await getDocumentosUseCase.getDocumentos(id, page, rowsPerPage);

          setDocumentos(getDocumentosUseCase.items);

          usePagination
            .getState()
            .documentosSetter.setRowsPerPage(getDocumentosUseCase.pageSize);
          usePagination
            .getState()
            .documentosSetter.setTotalItems(getDocumentosUseCase.totalItems);
        }
      } catch (e: unknown) {
        setDocumentos([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getDocumentosUseCase],
  );

  const loadDocumentosEntregues = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.documentosEntregues.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.documentosEntregues.rowsPerPage;

          await getDocumentosEntreguesUseCase.getDocumentosEntregues(
            id,
            page,
            rowsPerPage,
          );

          setDocumentosEntregues(getDocumentosEntreguesUseCase.items);

          usePagination
            .getState()
            .documentosEntreguesSetter.setRowsPerPage(
              getDocumentosEntreguesUseCase.pageSize,
            );
          usePagination
            .getState()
            .documentosEntreguesSetter.setTotalItems(
              getDocumentosEntreguesUseCase.totalItems,
            );
        }
      } catch (e: unknown) {
        setDocumentosEntregues([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getDocumentosEntreguesUseCase],
  );

  const loadFuncionarioTreinamentos = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.treinamentos.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.treinamentos.rowsPerPage;

          await getFuncionarioTreinamentosUseCase.getFuncionarioTreinamentos(
            id,
            page,
            rowsPerPage,
          );

          setFuncionarioTreinamentos(getFuncionarioTreinamentosUseCase.items);

          usePagination
            .getState()
            .treinamentosSetter.setRowsPerPage(
              getFuncionarioTreinamentosUseCase.pageSize,
            );
          usePagination
            .getState()
            .treinamentosSetter.setTotalItems(
              getFuncionarioTreinamentosUseCase.totalItems,
            );
        }
      } catch (e: unknown) {
        setFuncionarioTreinamentos([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getFuncionarioTreinamentosUseCase],
  );

  const loadHabilidades = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.habilidades.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.habilidades.rowsPerPage;

          await getHabilidadesUseCase.getHabilidades(id, page, rowsPerPage);

          setHabilidades(getHabilidadesUseCase.items);

          usePagination
            .getState()
            .habilidadesSetter.setRowsPerPage(getHabilidadesUseCase.pageSize);
          usePagination
            .getState()
            .habilidadesSetter.setTotalItems(getHabilidadesUseCase.totalItems);
        }
      } catch (e: unknown) {
        setHabilidades([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getHabilidadesUseCase],
  );

  const loadDependentes = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.dependentes.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.dependentes.rowsPerPage;

          await getDependentesUseCase.getDependentes(id, page, rowsPerPage);

          setDependentes(getDependentesUseCase.items);

          usePagination
            .getState()
            .dependentesSetter.setRowsPerPage(getDependentesUseCase.pageSize);
          usePagination
            .getState()
            .dependentesSetter.setTotalItems(getDependentesUseCase.totalItems);
        }
      } catch (e: unknown) {
        setDependentes([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getDependentesUseCase],
  );

  const loadEventos = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.eventos.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.eventos.rowsPerPage;

          await getEventosUseCase.getEventos(id, page, rowsPerPage);

          setEventos(getEventosUseCase.items);

          usePagination
            .getState()
            .eventosSetter.setRowsPerPage(getEventosUseCase.pageSize);
          usePagination
            .getState()
            .eventosSetter.setTotalItems(getEventosUseCase.totalItems);
        }
      } catch (e: unknown) {
        setEventos([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getEventosUseCase],
  );

  const loadFerias = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.ferias.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.ferias.rowsPerPage;

          await getFeriasUseCase.getFerias(id, page, rowsPerPage);

          setFerias(getFeriasUseCase.items);

          usePagination
            .getState()
            .feriasSetter.setRowsPerPage(getFeriasUseCase.pageSize);
          usePagination
            .getState()
            .feriasSetter.setTotalItems(getFeriasUseCase.totalItems);
        }
      } catch (e: unknown) {
        setFerias([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getFeriasUseCase],
  );

  const loadAfastamentos = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.afastamentos.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.afastamentos.rowsPerPage;

          await getAfastamentosUseCase.getAfastamentos(id, page, rowsPerPage);

          setAfastamentos(getAfastamentosUseCase.items);

          usePagination
            .getState()
            .afastamentosSetter.setRowsPerPage(getAfastamentosUseCase.pageSize);
          usePagination
            .getState()
            .afastamentosSetter.setTotalItems(
              getAfastamentosUseCase.totalItems,
            );
        }
      } catch (e: unknown) {
        setAfastamentos([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getAfastamentosUseCase],
  );

  const loadHabilidadeItems = useCallback(
    async (
      idHabilidade: number | null,
      params?: { page?: number; rowsPerPage?: number },
    ) => {
      try {
        const page = params?.page ?? pagination.habilidadeItems.page;
        const rowsPerPage =
          params?.rowsPerPage ?? pagination.habilidadeItems.rowsPerPage;

        if (idHabilidade) {
          await getHabilidadeItemsUseCase.getHabilidadeItems(
            idHabilidade,
            page,
            rowsPerPage,
          );
        } else {
          await getHabilidadeItemsUseCase.getHabilidadeItemsNew(
            page,
            rowsPerPage,
          );
        }

        setSelectedHabilidadeItems(getHabilidadeItemsUseCase.items);

        usePagination
          .getState()
          .habilidadeItemsSetter.setRowsPerPage(
            getHabilidadeItemsUseCase.pageSize,
          );
        usePagination
          .getState()
          .habilidadeItemsSetter.setTotalItems(
            getHabilidadeItemsUseCase.totalItems,
          );
      } catch (e: unknown) {
        setSelectedHabilidadeItems([]);
        throw e;
      }
    },
    [pagination, getHabilidadeItemsUseCase],
  );

  const loadControlePatrimonios = useCallback(
    async (params?: { id?: number; page?: number; rowsPerPage?: number }) => {
      try {
        const id = params?.id ?? idFuncionario;

        if (id) {
          const page = params?.page ?? pagination.controlePatrimonios.page;
          const rowsPerPage =
            params?.rowsPerPage ?? pagination.controlePatrimonios.rowsPerPage;

          await getControlePatrimoniosUseCase.getControlePatrimonios(
            id,
            page,
            rowsPerPage,
          );

          setControlePatrimonios(getControlePatrimoniosUseCase.items);

          usePagination
            .getState()
            .controlePatrimoniosSetter.setRowsPerPage(
              getControlePatrimoniosUseCase.pageSize,
            );
          usePagination
            .getState()
            .controlePatrimoniosSetter.setTotalItems(
              getControlePatrimoniosUseCase.totalItems,
            );
        }
      } catch (e: unknown) {
        setControlePatrimonios([]);
        throw e;
      }
    },
    [idFuncionario, pagination, getControlePatrimoniosUseCase],
  );

  const loadPage = useCallback(
    async (id?: number | undefined | null) => {
      try {
        const hasId = typeof id === "number";
        const jobs = [];

        jobs.push(loadCentroCustoDropDown());
        jobs.push(loadCargosDropDown());
        jobs.push(loadFuncionariosDropDown());
        jobs.push(loadMotivoDemissaoDropDown());
        jobs.push(loadTreinamentosDropDown());
        jobs.push(loadHabilidadesDropDown());
        jobs.push(loadItensVerbaDropDown());
        jobs.push(loadMotivosAfastamentoDropDown());
        jobs.push(loadEquipamentosDropDown());
        jobs.push(loadFuncionarioAssinaturasDropDown());

        if (hasId) {
          jobs.push(loadCentroCustoSecundarios({ id }));
        }
        if (hasId) {
          jobs.push(loadDocumentos({ id }));
        }
        if (hasId) {
          jobs.push(loadDocumentosEntregues({ id }));
        }
        if (hasId) {
          jobs.push(loadFuncionarioTreinamentos({ id }));
        }
        if (hasId) {
          jobs.push(loadHabilidades({ id }));
        }
        if (hasId) {
          jobs.push(loadDependentes({ id }));
        }
        if (hasId) {
          jobs.push(loadEventos({ id }));
        }
        if (hasId) {
          jobs.push(loadFerias({ id }));
        }
        if (hasId) {
          jobs.push(loadAfastamentos({ id }));
        }
        if (hasId) {
          jobs.push(loadControlePatrimonios({ id }));
        }
        if (hasId) {
          jobs.push(loadBiometriaFacial({ idFuncionario: id }));
        }
        if (hasId) {
          jobs.push(loadListaTermos());
        }

        await Promise.all(jobs);
      } catch (e: unknown) {
        throw e;
      }
    },
    [
      loadCentroCustoDropDown,
      loadCargosDropDown,
      loadFuncionariosDropDown,
      loadMotivoDemissaoDropDown,
      loadTreinamentosDropDown,
      loadHabilidadesDropDown,
      loadItensVerbaDropDown,
      loadMotivosAfastamentoDropDown,
      loadEquipamentosDropDown,
      loadFuncionarioAssinaturasDropDown,
      loadCentroCustoSecundarios,
      loadDocumentos,
      loadDocumentosEntregues,
      loadFuncionarioTreinamentos,
      loadHabilidades,
      loadDependentes,
      loadEventos,
      loadFerias,
      loadAfastamentos,
      loadControlePatrimonios,
      loadBiometriaFacial,
      loadListaTermos,
    ],
  );

  /**
   * UseEffect
   */

  usePageStartBootstrap(async () => {
    try {
      const params = new URLSearchParams(location.search);
      const locationId = params.get("id");
      const id = idFuncionario ?? locationId ?? null;

      const contentView = document.getElementById("body-container");
      contentView?.scrollIntoView({ behavior: "auto", block: "start" });

      setErrorMessage(undefined);
      setIdFuncionario(Number(id) > 0 ? Number(id) : undefined);

      if (id) {
        await loadFuncionario({ idFuncionario: Number(id) });
      } else {
        hookForm.reset({
          dataAdmissao: new Date(),
        });
      }

      await loadPage(Number(id));
    } catch (e: unknown) {
      setErrorMessage(processError(e, "Falha ao iniciar pagina!")[0]);
    }
  });

  /**
   * Eventos
   */

  const handleReloadPage = useCallback(async () => {
    try {
      setLoading(true);
      await loadFuncionario({ idFuncionario });
      await loadPage(idFuncionario);
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao iniciar pagina!"),
        { isAutoFinish: true },
      );
    } finally {
      setLoading(false);
    }
  }, [idFuncionario, loadFuncionario, loadPage, pushErrorNotification]);

  const handleRelatorio = useCallback(async () => {
    try {
      if (funcionario) {
        setLoading(true);

        await startReportViewerProcess({
          fetchCallback: async (requiredMimeType) =>
            await getReportCadastroFuncionarioUseCase.getReportCadastroFuncionario(
              requiredMimeType,
              funcionario.idFuncionario,
            ),
        });
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao iniciar pagina!"),
        { isAutoFinish: true },
      );
    } finally {
      setLoading(false);
    }
  }, [
    funcionario,
    getReportCadastroFuncionarioUseCase,
    startReportViewerProcess,
    pushErrorNotification,
  ]);

  const handleNewFuncionario = useCallback(() => {
    if (idFuncionario) {
      const newUrl = `${window.location.pathname}`;
      window.history.replaceState({}, "", newUrl);

      setIdFuncionario(undefined);
      setFuncionario(undefined);
      setSelectedCentroCustoSecundario(undefined);
      setSelectedDependente(undefined);
      setSelectedEvento(undefined);
      setSelectedFerias(undefined);
      setSelectedAfastamento(undefined);
      setSelectedFuncionarioTreinamento(undefined);
      setSelectedIdFuncionarioTreinamentosLote(undefined);
      setSelectedDocumento(undefined);
      setSelectedHabilidade(undefined);
      setSelectedHabilidadeItem(undefined);
      setSelectedHabilidadeItems(undefined);
      setSelectedControlePatrimonio(undefined);
      setOpenCadastroCentroCustoSecundarioModal(false);
      setOpenCadastroDependenteModal(false);
      setOpenCadastroEventoModal(false);
      setOpenCadastroFeriasModal(false);
      setOpenCadastroAfastamentoModal(false);
      setOpenDeletarCentroCustoSecundarioModal(false);
      setOpenDeletarDependenteModal(false);
      setOpenDeletarEventoModal(false);
      setOpenDeletarFeriasModal(false);
      setOpenDeletarAfastamentoModal(false);
      setOpenCadastroDocumentoModal(false);
      setOpenDeletarDocumentoModal(false);
      setOpenDeletarAllDocumentosModal(false);
      setOpenCadastroFuncionarioTreinamentoModal(false);
      setOpenAvaliarFuncionarioTreinamentoModal(false);
      setOpenDeletarFuncionarioTreinamentoModal(false);
      setOpenDeletarFuncionarioTreinamentosLoteModal(false);
      setOpenRelatorioFuncionarioTreinamentoModal(false);
      setOpenCadastroHabilidadeModal(false);
      setOpenDeletarHabilidadeModal(false);
      setOpenCadastroHabilidadeItemModal(false);
      setOpenDeletarHabilidadeItemModal(false);
      setOpenCadastroControlePatrimonioModal(false);
      setOpenDeletarControlePatrimonioModal(false);
      setCentroCustoSecundarios(undefined);
      setDependentes(undefined);
      setEventos(undefined);
      setFerias(undefined);
      setAfastamentos(undefined);
      setDocumentos(undefined);
      setDocumentosEntregues(undefined);
      setFuncionarioTreinamentos(undefined);
      setHabilidades(undefined);
      setControlePatrimonios(undefined);

      hookForm.reset({ dataAdmissao: new Date() });
    }
  }, [idFuncionario, hookForm]);

  const handleExcluirFuncionario = useCallback(async () => {
    try {
      if (funcionario) {
        if (
          window.confirm("Tem certeza que deseja excluir este funcionário?")
        ) {
          setPageSaving(true);
          setSaving(true);

          await deleteFuncionarioUseCase.deleteFuncionario(
            TelasIds.Funcionarios_cadastro,
            funcionario.idFuncionario,
          );

          backOrNavigate("/Funcionarios_lista");
        }
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao excluir funcionario!"),
        { isAutoFinish: true },
      );
    } finally {
      setPageSaving(false);
      setSaving(false);
    }
  }, [
    funcionario,
    deleteFuncionarioUseCase,
    backOrNavigate,
    pushErrorNotification,
    setPageSaving,
  ]);

  const handleTabChange = useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      setCurrentTab(newValue);
    },
    [],
  );

  const handleBack = useCallback(() => {
    if (!saving) backOrNavigate("/Funcionarios_lista");
  }, [saving, backOrNavigate]);

  const handleCancel = useCallback(() => {
    if (!saving) backOrNavigate("/Funcionarios_lista");
  }, [saving, backOrNavigate]);

  const handleLoadCep = useCallback(
    async (cep: string) => {
      try {
        setErrorMessage(undefined);
        const cepResponse = await getCepUseCase.getCep(cep);
        return cepResponse;
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao carregar CEP!"),
          { isAutoFinish: true },
        );
      }
    },
    [getCepUseCase, pushErrorNotification],
  );

  const handleStartFileUpload = useCallback(
    (file: File | null) => {
      if (fileUpload !== undefined) {
        URL.revokeObjectURL(fileUpload);
      }

      hookForm.setValue("imagem", file);

      const newFileUploadUrl = file ? URL.createObjectURL(file) : null;
      setFileUpload(newFileUploadUrl ?? undefined);

      if (newFileUploadUrl !== null) {
        requestAnimationFrame(() => {
          const imageComponent = document.getElementById("funcionarioImagem");
          if (imageComponent !== null) {
            if (imageComponent instanceof HTMLImageElement) {
              imageComponent.src = newFileUploadUrl;
            }
          }
        });
      }
    },
    [fileUpload, hookForm],
  );

  const handleDeleteFileUpload = useCallback(async () => {
    if (idFuncionario) {
      if (window.confirm("Você deseja excluir este item?")) {
        try {
          setLoading(true);

          await deleteFuncionarioImageByIdUseCase.deleteFuncionarioImageById(
            idFuncionario,
          );

          if (fileUpload !== undefined) {
            URL.revokeObjectURL(fileUpload);
          }

          try {
            const imageInput = document.getElementById("profileImageInput");
            if (imageInput instanceof HTMLInputElement) {
              imageInput.value = "";
            }
          } catch (_: unknown) { }

          hookForm.setValue("imagem", null);
          setFileUpload(undefined);

          requestAnimationFrame(() => {
            const imageComponent = document.getElementById("funcionarioImagem");
            if (imageComponent !== null) {
              if (imageComponent instanceof HTMLImageElement) {
                imageComponent.src = CommonConstants.assets.noAvatar;
              }
            }
          });
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao excluir imagem!"),
          );
        } finally {
          setLoading(false);
        }
      }
    }
  }, [
    idFuncionario,
    fileUpload,
    hookForm,
    deleteFuncionarioImageByIdUseCase,
    pushErrorNotification,
  ]);
  const handleSubmitFuncionario = useCallback(
    async (form: FuncionarioForm) => {
      try {
        if (!saving && !loading) {
          setPageSaving(true);
          setSaving(true);

          if (!funcionario) {
            const newIdFuncionario =
              await createFuncionarioUseCase.createFuncionario(
                form.idCargo,
                form.idCentroCusto,
                form.nome,
                form.sexo,
                form.dataAdmissao,
                form.regime,
                form.dataNascimento,
                form.demissaoIdDemissao,
                form.demissaoData,
                form.setor,
                form.avaliarHabilidadesEm,
                form.descontoSindical,
                form.filial,
                form.email1,
                form.email2,
                form.matricula,
                form.telefoneMovel,
                form.telefoneFixo,
                form.horarioTrabalho,
                form.horarioAlmoco,
                form.nacionalidade,
                form.naturalidade,
                form.estado,
                form.cpf,
                form.numeroPis,
                form.estadoCivil,
                form.salario,
                form.periodo,
                form.experiencia,
                form.prorrogarEm,
                form.aprovadoExperiencia,
                form.escolaridade,
                form.cargaHorarioMensal,
                form.valeTransporte,
                form.valorValeTransporte,
                form.ctps,
                form.ctpsSerie,
                form.ctpsEstado,
                form.ctpsDataEmissao,
                form.rg,
                form.rgDataExped,
                form.rgOrgaoExped,
                form.rgEstado,
                form.tituloEleitor,
                form.tituloZona,
                form.tituloSecao,
                form.reservista,
                form.nomeMae,
                form.nomePai,
                form.conjugeNome,
                form.conjugeRg,
                form.conjugeCpf,
                form.complementoCamisaInfo,
                form.complementoCalcaInfo,
                form.complementoCalcadoInfo,
                form.enderecoCep,
                form.enderecoCidade,
                form.enderecoEndereco,
                form.enderecoNumero,
                form.enderecoComplemento,
                form.enderecoBairro,
                form.enderecoEstado,
                form.enderecoPais,
                form.bancTipoInfo,
                form.bancBancoInfo,
                form.bancAgenciaInfo,
                form.bancContaInfo,
                form.bancContaDigitoInfo,
                form.bancOperacaoInfo,
                form.bancPixInfo,
                form.observacaoGeral,
                form.observacaoDocumento,
                form.demissaoData,
                form.inicioAvisoPrevio,
                form.fimAvisoPrevio,
                form.imagem,
                form.horarioTrabalhoSegQui,
                form.horarioTrabalhoSex,
              );

            setLoading(true);

            await loadHabilidades({ id: newIdFuncionario, page: 1 });
            await loadFuncionarioTreinamentos({
              id: newIdFuncionario,
              page: 1,
            });
            await loadFuncionario({ idFuncionario: newIdFuncionario });
            await loadPage(newIdFuncionario);

            const params = new URLSearchParams(window.location.search);
            params.set("id", newIdFuncionario.toString());

            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({}, "", newUrl);

            setLoading(false);
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          } else {
            await updateFuncionarioUseCase.updateFuncionario(
              funcionario.idFuncionario,
              form.idCargo,
              form.idCentroCusto,
              form.nome,
              form.sexo,
              form.dataAdmissao,
              form.regime,
              form.dataNascimento,
              form.demissaoIdDemissao,
              form.demissaoData,
              form.setor,
              form.avaliarHabilidadesEm,
              form.descontoSindical,
              form.filial,
              form.email1,
              form.email2,
              form.matricula,
              form.telefoneMovel,
              form.telefoneFixo,
              form.horarioTrabalho,
              form.horarioAlmoco,
              form.nacionalidade,
              form.naturalidade,
              form.estado,
              form.cpf,
              form.numeroPis,
              form.estadoCivil,
              form.salario,
              form.periodo,
              form.experiencia,
              form.prorrogarEm,
              form.aprovadoExperiencia,
              form.escolaridade,
              form.cargaHorarioMensal,
              form.valeTransporte,
              form.valorValeTransporte,
              form.ctps,
              form.ctpsSerie,
              form.ctpsEstado,
              form.ctpsDataEmissao,
              form.rg,
              form.rgDataExped,
              form.rgOrgaoExped,
              form.rgEstado,
              form.tituloEleitor,
              form.tituloZona,
              form.tituloSecao,
              form.reservista,
              form.nomeMae,
              form.nomePai,
              form.conjugeNome,
              form.conjugeRg,
              form.conjugeCpf,
              form.complementoCamisaInfo,
              form.complementoCalcaInfo,
              form.complementoCalcadoInfo,
              form.enderecoCep,
              form.enderecoCidade,
              form.enderecoEndereco,
              form.enderecoNumero,
              form.enderecoComplemento,
              form.enderecoBairro,
              form.enderecoEstado,
              form.enderecoPais,
              form.bancTipoInfo,
              form.bancBancoInfo,
              form.bancAgenciaInfo,
              form.bancContaInfo,
              form.bancContaDigitoInfo,
              form.bancOperacaoInfo,
              form.bancPixInfo,
              form.observacaoGeral,
              form.observacaoDocumento,
              form.demissaoData,
              form.imagem,
              form.inicioAvisoPrevio,
              form.fimAvisoPrevio,
              form.documentosEntregues,
              form.horarioTrabalhoSegQui,
              form.horarioTrabalhoSex,
            );

            await loadHabilidades({ page: 1 });
            await loadFuncionarioTreinamentos({ page: 1 });
            await loadFuncionario();

            if (form.documentosEntregues) {
              await loadDocumentosEntregues();
              hookForm.setValue("documentosEntregues", null);
            }
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar usuário!"),
        );
      } finally {
        setSaving(false);
        setPageSaving(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      createFuncionarioUseCase,
      updateFuncionarioUseCase,
      hookForm,
      loadHabilidades,
      loadFuncionarioTreinamentos,
      loadFuncionario,
      loadDocumentosEntregues,
      loadPage,
      setPageSaving,
      pushInfoNotification,
      pushErrorNotification,
    ],
  );

  const handleSubmitCentroCustoSecundario = useCallback(
    async (form: CentroCustoSecundarioForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedCentroCustoSecundario) {
              await createCentroCustoSecundarioUseCase.createCentroCustoSecundario(
                funcionario.idFuncionario,
                form.idCentroCusto,
              );
            } else {
              await updateCentroCustoSecundarioUseCase.updateCentroCustoSecundario(
                selectedCentroCustoSecundario.idCentroCustoSecundario,
                form.idCentroCusto,
              );
            }
            await loadCentroCustoSecundarios();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar centro de custo secundario!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroCentroCustoSecundarioModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedCentroCustoSecundario,
      createCentroCustoSecundarioUseCase,
      updateCentroCustoSecundarioUseCase,
      loadCentroCustoSecundarios,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitDependente = useCallback(
    async (form: DependenteForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedDependente) {
              await createDependenteUseCase.createDependente(
                funcionario.idFuncionario,
                form.nome,
                form.dataNascimento,
                form.cpf,
                form.rg,
                form.grauParentesco,
              );
            } else {
              await updateDependenteUseCase.updateDependente(
                selectedDependente.idDependente,
                form.nome,
                form.dataNascimento,
                form.cpf,
                form.rg,
                form.grauParentesco,
              );
            }
            await loadDependentes();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar dependente!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroDependenteModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedDependente,
      createDependenteUseCase,
      updateDependenteUseCase,
      loadDependentes,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitEvento = useCallback(
    async (form: EventoForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedEvento) {
              await createEventoUseCase.createEvento(
                funcionario.idFuncionario,
                form.idItemVerba,
                form.valor,
                form.descricao,
              );
            } else {
              await updateEventoUseCase.updateEvento(
                selectedEvento.idItemVerbaFuncionario,
                form.idItemVerba,
                form.valor,
                form.descricao,
              );
            }
            await loadEventos();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar evento!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroEventoModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedEvento,
      createEventoUseCase,
      updateEventoUseCase,
      loadEventos,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitFerias = useCallback(
    async (form: FeriasForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedFerias) {
              await createFeriasUseCase.createFerias(
                funcionario.idFuncionario,
                form.descricao,
                form.dataInicio,
                form.dataTermino,
              );
            } else {
              await updateFeriasUseCase.updateFerias(
                selectedFerias.idFerias,
                form.descricao,
                form.dataInicio,
                form.dataTermino,
              );
            }
            await loadFerias();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar ferias!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroFeriasModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedFerias,
      createFeriasUseCase,
      updateFeriasUseCase,
      loadFerias,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitAfastamento = useCallback(
    async (form: AfastamentoForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedAfastamento) {
              await createAfastamentoUseCase.createAfastamento(
                funcionario.idFuncionario,
                form.idMotivoAfastamento,
                form.dataInicio,
                form.dataTermino,
                form.observacao,
              );
            } else {
              await updateAfastamentoUseCase.updateAfastamento(
                selectedAfastamento.idAfastamento,
                form.idMotivoAfastamento,
                form.dataInicio,
                form.dataTermino,
                form.observacao,
              );
            }
            await loadFuncionario();
            await loadAfastamentos();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar afastamento!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroAfastamentoModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedAfastamento,
      createAfastamentoUseCase,
      updateAfastamentoUseCase,
      loadFuncionario,
      loadAfastamentos,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitDocumento = useCallback(
    async (form: DocumentoForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedDocumento) {
              await createDocumentoUseCase.createDocumento(
                funcionario.idFuncionario,
                form.statusArquivo,
                form.nomeDocumento,
                form.dataVencimento,
                form.dataEmissao,
                form.file,
              );
            } else {
              await updateDocumentoUseCase.updateDocumento(
                selectedDocumento.idDocumento,
                form.statusArquivo,
                form.nomeDocumento,
                form.dataVencimento,
                form.dataEmissao,
                form.file,
                form.limparArquivos,
              );
            }
            await loadDocumentos();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
            setOpenCadastroDocumentoModal(false);
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedDocumento,
      createDocumentoUseCase,
      updateDocumentoUseCase,
      loadDocumentos,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitTreinamento = useCallback(
    async (form: TreinamentoForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedFuncionarioTreinamento) {
              await createFuncionarioTreinamentoUseCase.createFuncionarioTreinamento(
                funcionario.idFuncionario,
                form.idTreinamento,
                form.cargaHoraria,
                form.local,
                form.instrutor,
                form.dataRealização,
                form.prazoAvaliacao,
              );
            } else {
              await updateFuncionarioTreinamentoUseCase.updateFuncionarioTreinamento(
                selectedFuncionarioTreinamento.idFuncionarioTreinamento,
                form.idTreinamento,
                form.cargaHoraria,
                form.local,
                form.instrutor,
                form.dataRealização,
                form.prazoAvaliacao,
              );
            }
            await loadFuncionarioTreinamentos();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroFuncionarioTreinamentoModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedFuncionarioTreinamento,
      createFuncionarioTreinamentoUseCase,
      updateFuncionarioTreinamentoUseCase,
      loadFuncionarioTreinamentos,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitAvaliarTreinamento = useCallback(
    async (form: AvaliarTreinamentoForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (selectedFuncionarioTreinamento) {
              await avaliarTreinamentoUseCase.avaliarTreinamento(
                selectedFuncionarioTreinamento.idFuncionarioTreinamento,
                form.eficaz,
                form.avaliador,
                form.dataAvaliacao,
                form.evidenciaObjetiva,
              );
            } else if (selectedIdFuncionarioTreinamentosLote) {
              await avaliarTreinamentoUseCase.avaliarTreinamentoLote(
                selectedIdFuncionarioTreinamentosLote,
                form.eficaz,
                form.avaliador,
                form.dataAvaliacao,
                form.evidenciaObjetiva,
              );
            }
            await loadFuncionarioTreinamentos();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
        );
      } finally {
        setSaving(false);
        setOpenAvaliarFuncionarioTreinamentoModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedFuncionarioTreinamento,
      selectedIdFuncionarioTreinamentosLote,
      avaliarTreinamentoUseCase,
      loadFuncionarioTreinamentos,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitAvaliarHabilidade = useCallback(
    async (form: AvaliacaoHabilidadeForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (selectedHabilidade) {
              await updateAvaliacaoHabilidadeUseCase.updateAvaliacaoHabilidade(
                selectedHabilidade.idAvaliacaoHabilidade,
                form.descricao,
                form.data,
                form.idAvaliadoPor,
                form.dataReavaliacao,
                form.observacao,
                form.habilidadeItems,
              );

              await loadHabilidades();
              pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
            }
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroHabilidadeModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedHabilidade,
      updateAvaliacaoHabilidadeUseCase,
      loadHabilidades,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitAvaliarHabilidadeItem = useCallback(
    async (form: HabilidadeItemForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (selectedHabilidade) {
            if (!selectedHabilidadeItem) {
              await createAvaliacaoHabilidadeItemUseCase.createAvaliacaoHabilidadeItem(
                selectedHabilidade.idAvaliacaoHabilidade,
                form.idHabilidade,
                form.nota,
              );

              setSelectedHabilidade(
                createAvaliacaoHabilidadeItemUseCase.avaliacaoHabilidade,
              );
              setSelectedHabilidadeItems(
                createAvaliacaoHabilidadeItemUseCase.habilidades,
              );
            } else {
              await updateAvaliacaoHabilidadeItemUseCase.updateAvaliacaoHabilidadeItem(
                selectedHabilidadeItem.idHabilidadeItem,
                form.idHabilidade,
                form.nota,
              );

              setSelectedHabilidade(
                updateAvaliacaoHabilidadeItemUseCase.avaliacaoHabilidade,
              );
              setSelectedHabilidadeItems(
                updateAvaliacaoHabilidadeItemUseCase.habilidades,
              );
            }
            await loadHabilidades();
            pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroHabilidadeItemModal(false);
      }
    },
    [
      saving,
      loading,
      selectedHabilidade,
      selectedHabilidadeItem,
      createAvaliacaoHabilidadeItemUseCase,
      updateAvaliacaoHabilidadeItemUseCase,
      loadHabilidades,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitControlePatrimonio = useCallback(
    async (form: ControlePatrimonioForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!selectedControlePatrimonio) {
              await createControlePatrimonioUseCase.createControlePatrimonio(
                funcionario.idFuncionario,
                form.idMaquinaEquip,
                form.dataEntrega,
                form.dataDevolucao,
                form.observacoes,
                form.files,
              );
            } else {
              await updateControlePatrimonioUseCase.updateControlePatrimonio(
                selectedControlePatrimonio.idControlePatrimonio,
                form.idMaquinaEquip,
                form.dataEntrega,
                form.dataDevolucao,
                form.observacoes,
                form.files,
              );
            }
          }
          await loadControlePatrimonios();
          pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
        );
      } finally {
        setSaving(false);
        setOpenCadastroControlePatrimonioModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      selectedControlePatrimonio,
      createControlePatrimonioUseCase,
      updateControlePatrimonioUseCase,
      loadControlePatrimonios,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleSubmitRelatorioFuncionarioTreinamento = useCallback(
    async (form: RelatorioFuncionarioTreinamentoForm) => {
      try {
        setLoading(true);
        if (selectedFuncionarioTreinamento) {
          await startReportViewerProcess({
            fetchCallback: async (requiredMimeType) =>
              await getReportFuncionarioTreinamentoUseCase.getReportFuncionarioTreinamento(
                requiredMimeType,
                selectedFuncionarioTreinamento.idFuncionarioTreinamento,
                form.exibirConteudoProgramatico,
                form.instrutorAssinatura,
              ),
            closeReportModalCallback: () => {
              setSelectedFuncionarioTreinamento(undefined);
              setOpenRelatorioFuncionarioTreinamentoModal(false);
            },
          });
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      selectedFuncionarioTreinamento,
      getReportFuncionarioTreinamentoUseCase,
      startReportViewerProcess,
      pushErrorNotification,
    ],
  );

  /**
   * Eventos informacoes gerais
   */

  const handleCadastroCentroCustoSecundarioOpenState = useCallback(
    (idCentroCustoSecundario: number | null, openState: boolean) => {
      if (openState) {
        if (idCentroCustoSecundario && centroCustoSecundarios) {
          const item = centroCustoSecundarios.find(
            (x) => x.idCentroCustoSecundario === idCentroCustoSecundario,
          );
          setSelectedCentroCustoSecundario(item);
        } else {
          setSelectedCentroCustoSecundario(undefined);
        }
      }
      setOpenCadastroCentroCustoSecundarioModal(openState);
    },
    [centroCustoSecundarios],
  );

  const handleCadastroDependenteOpenState = useCallback(
    (idDependente: number | null, openState: boolean) => {
      if (openState) {
        if (idDependente && dependentes) {
          setSelectedDependente(
            dependentes.find((x) => x.idDependente === idDependente),
          );
        } else {
          setSelectedDependente(undefined);
        }
      }
      setOpenCadastroDependenteModal(openState);
    },
    [dependentes],
  );

  const handleCadastroEventoOpenState = useCallback(
    (idItemVerbaFuncionario: number | null, openState: boolean) => {
      if (openState) {
        if (idItemVerbaFuncionario && eventos) {
          setSelectedEvento(
            eventos.find(
              (x) => x.idItemVerbaFuncionario === idItemVerbaFuncionario,
            ),
          );
        } else {
          setSelectedEvento(undefined);
        }
      }
      setOpenCadastroEventoModal(openState);
    },
    [eventos],
  );

  const handleCadastroFeriasOpenState = useCallback(
    (idFerias: number | null, openState: boolean) => {
      if (openState) {
        if (idFerias && ferias) {
          setSelectedFerias(ferias.find((x) => x.idFerias === idFerias));
        } else {
          setSelectedFerias(undefined);
        }
      }
      setOpenCadastroFeriasModal(openState);
    },
    [ferias],
  );

  const handleCadastroAfastamentoOpenState = useCallback(
    (idAfastamento: number | null, openState: boolean) => {
      if (openState) {
        if (idAfastamento && afastamentos) {
          setSelectedAfastamento(
            afastamentos.find((x) => x.idAfastamento === idAfastamento),
          );
        } else {
          setSelectedAfastamento(undefined);
        }
      }
      setOpenCadastroAfastamentoModal(openState);
    },
    [afastamentos],
  );

  const handleDeletarCentroCustoSecundarioOpenState = useCallback(
    (idCentroCustoSecundario: number | null, openState: boolean) => {
      if (openState) {
        if (idCentroCustoSecundario && centroCustoSecundarios) {
          setSelectedCentroCustoSecundario(
            centroCustoSecundarios.find(
              (x) => x.idCentroCustoSecundario === idCentroCustoSecundario,
            ),
          );
        } else {
          setSelectedCentroCustoSecundario(undefined);
        }
      }
      setOpenDeletarCentroCustoSecundarioModal(openState);
    },
    [centroCustoSecundarios],
  );

  const handleDeletarDependenteOpenState = useCallback(
    (idDependente: number | null, openState: boolean) => {
      if (openState) {
        if (idDependente && dependentes) {
          setSelectedDependente(
            dependentes.find((x) => x.idDependente === idDependente),
          );
        } else {
          setSelectedDependente(undefined);
        }
      }
      setOpenDeletarDependenteModal(openState);
    },
    [dependentes],
  );

  const handleDeletarEventoOpenState = useCallback(
    (idItemVerbaFuncionario: number | null, openState: boolean) => {
      if (openState) {
        if (idItemVerbaFuncionario && eventos) {
          setSelectedEvento(
            eventos.find(
              (x) => x.idItemVerbaFuncionario === idItemVerbaFuncionario,
            ),
          );
        } else {
          setSelectedEvento(undefined);
        }
      }
      setOpenDeletarEventoModal(openState);
    },
    [eventos],
  );

  const handleDeletarFeriasOpenState = useCallback(
    (idFerias: number | null, openState: boolean) => {
      if (openState) {
        if (idFerias && ferias) {
          setSelectedFerias(ferias.find((x) => x.idFerias === idFerias));
        } else {
          setSelectedFerias(undefined);
        }
      }
      setOpenDeletarFeriasModal(openState);
    },
    [ferias],
  );

  const handleDeletarAfastamentoOpenState = useCallback(
    (idAfastamento: number | null, openState: boolean) => {
      if (openState) {
        if (idAfastamento && afastamentos) {
          setSelectedAfastamento(afastamentos.find((x) => x.idAfastamento));
        } else {
          setSelectedAfastamento(undefined);
        }
      }
      setOpenDeletarAfastamentoModal(openState);
    },
    [afastamentos],
  );

  const handleConfirmarDeletarCentroCustoSecundario = useCallback(async () => {
    try {
      if (selectedCentroCustoSecundario) {
        setSaving(true);

        await deleteCentroCustoSecundarioUseCase.deleteCentroCustoSecundario(
          selectedCentroCustoSecundario.idCentroCustoSecundario,
        );

        await loadCentroCustoSecundarios();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar centro de custo!"),
      );
    } finally {
      setSaving(false);
      setSelectedCentroCustoSecundario(undefined);
      setOpenDeletarCentroCustoSecundarioModal(false);
    }
  }, [
    selectedCentroCustoSecundario,
    deleteCentroCustoSecundarioUseCase,
    loadCentroCustoSecundarios,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleConfirmarDeletarDependente = useCallback(async () => {
    try {
      if (selectedDependente) {
        setSaving(true);

        await deleteDependenteUseCase.deleteDependente(
          selectedDependente.idDependente,
        );

        await loadDependentes();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar dependente!"),
      );
    } finally {
      setSaving(false);
      setSelectedDependente(undefined);
      setOpenDeletarDependenteModal(false);
    }
  }, [
    selectedDependente,
    deleteDependenteUseCase,
    loadDependentes,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleConfirmarDeletarEvento = useCallback(async () => {
    try {
      if (selectedEvento) {
        setSaving(true);

        await deleteEventoUseCase.deleteEvento(
          selectedEvento.idItemVerbaFuncionario,
        );

        await loadEventos();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar evento!"),
      );
    } finally {
      setSaving(false);
      setSelectedEvento(undefined);
      setOpenDeletarEventoModal(false);
    }
  }, [
    selectedEvento,
    deleteEventoUseCase,
    loadEventos,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleConfirmarDeletarFerias = useCallback(async () => {
    try {
      if (selectedFerias) {
        setSaving(true);

        await deleteFeriasUseCase.deleteFerias(selectedFerias.idFerias);

        await loadFerias();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar ferias!"),
      );
    } finally {
      setSaving(false);
      setSelectedFerias(undefined);
      setOpenDeletarFeriasModal(false);
    }
  }, [
    selectedFerias,
    deleteFeriasUseCase,
    loadFerias,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleConfirmarDeletarAfastamento = useCallback(async () => {
    try {
      if (selectedAfastamento) {
        setSaving(true);

        await deleteAfastamentoUseCase.deleteAfastamento(
          selectedAfastamento.idAfastamento,
        );

        await loadAfastamentos();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar afastamento!"),
      );
    } finally {
      setSaving(false);
      setSelectedAfastamento(undefined);
      setOpenDeletarAfastamentoModal(false);
    }
  }, [
    selectedAfastamento,
    deleteAfastamentoUseCase,
    loadAfastamentos,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleCentroCustoSecundarioPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().centroCustoSecundariosSetter.setPage(page + 1);
        await loadCentroCustoSecundarios({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadCentroCustoSecundarios, pushErrorNotification],
  );

  const handleCentroCustoSecundarioRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination
          .getState()
          .centroCustoSecundariosSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().centroCustoSecundariosSetter.setPage(1);
        await loadCentroCustoSecundarios({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadCentroCustoSecundarios, pushErrorNotification],
  );

  const handleDependentesPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().dependentesSetter.setPage(page + 1);
        await loadDependentes({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadDependentes, pushErrorNotification],
  );

  const handleDependentesRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination.getState().dependentesSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().dependentesSetter.setPage(1);
        await loadDependentes({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadDependentes, pushErrorNotification],
  );

  const handleEventosPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().eventosSetter.setPage(page + 1);
        await loadEventos({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadEventos, pushErrorNotification],
  );

  const handleEventosRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination.getState().eventosSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().eventosSetter.setPage(1);
        await loadEventos({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadEventos, pushErrorNotification],
  );

  const handleFeriasPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().feriasSetter.setPage(page + 1);
        await loadFerias({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadFerias, pushErrorNotification],
  );

  const handleFeriasRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination.getState().feriasSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().feriasSetter.setPage(1);
        await loadFerias({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadFerias, pushErrorNotification],
  );

  const handleAfastamentoPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().afastamentosSetter.setPage(page + 1);
        await loadAfastamentos({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadAfastamentos, pushErrorNotification],
  );

  const handleAfastamentoRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination.getState().afastamentosSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().afastamentosSetter.setPage(1);
        await loadAfastamentos({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadAfastamentos, pushErrorNotification],
  );

  /**
   * Eventos documentos
   */

  const handleDocumentosPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().documentosSetter.setPage(page + 1);
        await loadDocumentos({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadDocumentos, pushErrorNotification],
  );

  const handleDocumentosRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination.getState().documentosSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().documentosSetter.setPage(1);
        await loadDocumentos({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadDocumentos, pushErrorNotification],
  );

  const handleDocumentosEntreguesPageChange = useCallback(
    (page: number) => {
      try {
        usePagination.getState().documentosEntreguesSetter.setPage(page + 1);
        loadDocumentosEntregues({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadDocumentosEntregues, pushErrorNotification],
  );

  const handleDocumentosEntreguesRowsPerPageChange = useCallback(
    (rowsPerPage: number) => {
      try {
        usePagination
          .getState()
          .documentosEntreguesSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().documentosEntreguesSetter.setPage(1);
        loadDocumentosEntregues({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadDocumentosEntregues, pushErrorNotification],
  );

  const handleCadastroDocumentoOpenState = useCallback(
    (idDocumento: number | null, openState: boolean) => {
      if (openState) {
        if (documentos && idDocumento) {
          const documento = documentos.find(
            (x) => x.idDocumento === idDocumento,
          );
          setSelectedDocumento(documento);
        } else {
          setSelectedDocumento(undefined);
        }
      }
      setOpenCadastroDocumentoModal(openState);
    },
    [documentos],
  );

  const handleDeletarDocumentoOpenState = useCallback(
    (idDocumento: number | null, openState: boolean) => {
      if (openState) {
        if (idDocumento && documentos) {
          setSelectedDocumento(
            documentos.find((x) => x.idDocumento === idDocumento),
          );
        } else {
          setSelectedDocumento(undefined);
        }
      }
      setOpenDeletarDocumentoModal(openState);
    },
    [documentos],
  );

  const handleConfirmarDeletarDocumento = useCallback(async () => {
    try {
      if (selectedDocumento) {
        setSaving(true);

        await deleteDocumentoUseCase.deleteDocumento(
          selectedDocumento.idDocumento,
        );

        await loadDocumentos();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar documento!"),
      );
    } finally {
      setSaving(false);
      setSelectedDocumento(undefined);
      setOpenDeletarDocumentoModal(false);
    }
  }, [
    selectedDocumento,
    deleteDocumentoUseCase,
    loadDocumentos,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleDeletarAllDocumentosOpenState = useCallback(
    (openState: boolean) => {
      setOpenDeletarAllDocumentosModal(openState);
    },
    [],
  );

  const handleConfirmarDeletarAllDocumentos = useCallback(async () => {
    try {
      if (funcionario) {
        setSaving(true);

        await deleteAllDocumentosUseCase.deleteAllDocumentos(
          funcionario.idFuncionario,
        );

        await loadDocumentos();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar todos documento!"),
      );
    } finally {
      setSaving(false);
      setOpenDeletarAllDocumentosModal(false);
    }
  }, [
    funcionario,
    deleteAllDocumentosUseCase,
    loadDocumentos,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleDownloadDocumento = useCallback(
    async (idFuncionarioArquivo: number, imageName: string) => {
      try {
        setCustomLoading(true);
        await downloadFuncionarioDocumentoByIdUseCase.downloadFuncionarioDocumentoById(
          idFuncionarioArquivo,
          imageName,
        );
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao baixar documento!"),
        );
      } finally {
        setCustomLoading(false);
      }
    },
    [
      downloadFuncionarioDocumentoByIdUseCase,
      pushErrorNotification,
      setCustomLoading,
    ],
  );

  const handleFuncionarioGetAllDocumentos = useCallback(async () => {
    try {
      if (funcionario) {
        setCustomLoading(true);

        const response = await getFuncionarioAllDocumentosUseCase
          .getFuncionariosAllDocumentos(funcionario.idFuncionario);

        setJobId(response.operacaoId);
        setOpenJobWaiterModel(true);
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao baixar todos os documentos!"),
      );
    } finally {
      setCustomLoading(false);
    }
  }, [
    funcionario,
    getFuncionarioAllDocumentosUseCase,
    pushErrorNotification,
    setCustomLoading,
  ]);

  /**
   * Eventos treinamento.
   */

  const handleCadastroFuncionarioTreinamentoOpenState = useCallback(
    (idFuncionarioTreinamento: number | null, openState: boolean) => {
      if (openState) {
        if (funcionarioTreinamentos && idFuncionarioTreinamento) {
          const treinamento = funcionarioTreinamentos.find(
            (x) => x.idFuncionarioTreinamento === idFuncionarioTreinamento,
          );
          setSelectedFuncionarioTreinamento(treinamento);
        } else {
          setSelectedFuncionarioTreinamento(undefined);
        }
      }
      setOpenCadastroFuncionarioTreinamentoModal(openState);
    },
    [funcionarioTreinamentos],
  );

  const handleAvaliarFuncionarioTreinamentoOpenState = useCallback(
    (idFuncionarioTreinamento: number | null, openState: boolean) => {
      if (openState) {
        if (funcionarioTreinamentos && idFuncionarioTreinamento) {
          const treinamento = funcionarioTreinamentos.find(
            (x) => x.idFuncionarioTreinamento === idFuncionarioTreinamento,
          );
          if (treinamento && treinamento.status !== 3) {
            setSelectedFuncionarioTreinamento(treinamento);
            setSelectedIdFuncionarioTreinamentosLote(undefined);
          } else {
            setSelectedFuncionarioTreinamento(undefined);
            setSelectedIdFuncionarioTreinamentosLote(undefined);
            pushWarnNotification(
              "Alerta",
              "Este treinamento não pode ser avaliado, pois, ainda não foi realizado!",
            );
            return;
          }
        } else {
          setSelectedFuncionarioTreinamento(undefined);
        }
      }
      setOpenAvaliarFuncionarioTreinamentoModal(openState);
    },
    [funcionarioTreinamentos, pushWarnNotification],
  );

  const handleAvaliarLoteTreinamentoOpenState = useCallback(
    (idFuncionarioTreinamentoLote: number[], openState: boolean) => {
      if (idFuncionarioTreinamentoLote) {
        setSelectedIdFuncionarioTreinamentosLote(idFuncionarioTreinamentoLote);
        setSelectedFuncionarioTreinamento(undefined);
      } else {
        setSelectedIdFuncionarioTreinamentosLote(undefined);
      }
      setOpenAvaliarFuncionarioTreinamentoModal(openState);
    },
    [],
  );

  const handleEditarFuncionarioTreinamento = useCallback(
    (idFuncionarioTreinamento: number | null, openState: boolean) => {
      if (openState) {
        if (funcionarioTreinamentos && idFuncionarioTreinamento) {
          const treinamento = funcionarioTreinamentos.find(
            (x) => x.idFuncionarioTreinamento === idFuncionarioTreinamento,
          );
          setSelectedFuncionarioTreinamento(treinamento);
        } else {
          setSelectedFuncionarioTreinamento(undefined);
        }
      }
      setOpenCadastroFuncionarioTreinamentoModal(openState);
    },
    [funcionarioTreinamentos],
  );

  const handleFuncionarioTreinamentosPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().treinamentosSetter.setPage(page + 1);
        await loadFuncionarioTreinamentos({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadFuncionarioTreinamentos, pushErrorNotification],
  );

  const handleFuncionarioTreinamentosRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination.getState().treinamentosSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().treinamentosSetter.setPage(1);
        await loadFuncionarioTreinamentos({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadFuncionarioTreinamentos, pushErrorNotification],
  );

  const handleDeletarFuncionarioTreinamentoOpenState = useCallback(
    (idFuncionarioTreinamento: number | null, openState: boolean) => {
      if (openState) {
        if (idFuncionarioTreinamento && funcionarioTreinamentos) {
          setSelectedFuncionarioTreinamento(
            funcionarioTreinamentos.find(
              (x) => x.idFuncionarioTreinamento === idFuncionarioTreinamento,
            ),
          );
        } else {
          setSelectedFuncionarioTreinamento(undefined);
        }
      }
      setOpenDeletarFuncionarioTreinamentoModal(openState);
    },
    [funcionarioTreinamentos],
  );

  const handleDeletarTreinamentosLoteOpenState = useCallback(
    (idFuncionarioTreinamentosLote: number[], openState: boolean) => {
      setSelectedIdFuncionarioTreinamentosLote(idFuncionarioTreinamentosLote);
      setOpenDeletarFuncionarioTreinamentosLoteModal(openState);
    },
    [],
  );

  const handleConfirmarDeletarFuncionarioTreinamento = useCallback(async () => {
    try {
      if (selectedFuncionarioTreinamento) {
        setSaving(true);

        await deleteFuncionarioTreinamentoUseCase.deleteFuncionarioTreinamento(
          selectedFuncionarioTreinamento.idFuncionarioTreinamento,
        );

        await loadFuncionarioTreinamentos();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar funcionario treinamento!"),
      );
    } finally {
      setSaving(false);
      setSelectedFuncionarioTreinamento(undefined);
      setOpenDeletarFuncionarioTreinamentoModal(false);
    }
  }, [
    selectedFuncionarioTreinamento,
    deleteFuncionarioTreinamentoUseCase,
    loadFuncionarioTreinamentos,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleConfirmarDeletarFuncionarioTreinamentosLote =
    useCallback(async () => {
      try {
        if (funcionario && selectedIdFuncionarioTreinamentosLote) {
          setSaving(true);

          await deleteFuncionarioTreinamentosLoteUseCase.deleteFuncionarioTreinamentosLote(
            funcionario.idFuncionario,
            selectedIdFuncionarioTreinamentosLote,
          );

          await loadFuncionarioTreinamentos();
          pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao deletar funcionario treinamentos!"),
        );
      } finally {
        setSaving(false);
        setSelectedIdFuncionarioTreinamentosLote(undefined);
        setOpenDeletarFuncionarioTreinamentosLoteModal(false);
      }
    }, [
      funcionario,
      selectedIdFuncionarioTreinamentosLote,
      deleteFuncionarioTreinamentosLoteUseCase,
      loadFuncionarioTreinamentos,
      pushErrorNotification,
      pushInfoNotification,
    ]);

  const handleRelatorioFuncionarioTreinamentoOpenState = useCallback(
    (idAvaliacaoTreinamento: number | null, openState: boolean) => {
      if (openState) {
        if (idAvaliacaoTreinamento && funcionarioTreinamentos) {
          const funcionarioTreinamento = funcionarioTreinamentos.find(
            (x) => x.idFuncionarioTreinamento === idAvaliacaoTreinamento,
          );
          setSelectedFuncionarioTreinamento(funcionarioTreinamento);
        } else {
          setSelectedFuncionarioTreinamento(undefined);
        }
      }
      setOpenRelatorioFuncionarioTreinamentoModal(openState);
    },
    [funcionarioTreinamentos],
  );

  const handleCertificadoFuncionarioTreinamentoSubmit = useCallback(
    async (idFuncionarioTreinamento: number) => {
      try {
        setSaving(true);

        await generateCertificateUseCase.generateCertificate(
          idFuncionarioTreinamento,
        );

        pushInfoNotification("Sucesso", "Registro gerado com sucesso!");
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao gerar certificado de treinamento!"),
        );
      } finally {
        setSaving(false);
      }
    },
    [
      generateCertificateUseCase,
      pushInfoNotification,
      pushErrorNotification,
    ],
  );

  /**
   * Eventos habilidades
   */

  const handleHabilidadesPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().habilidadesSetter.setPage(page + 1);
        await loadHabilidades({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadHabilidades, pushErrorNotification],
  );

  const handleHabilidadesRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination.getState().habilidadesSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().habilidadesSetter.setPage(1);
        await loadHabilidades({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadHabilidades, pushErrorNotification],
  );

  const handleCadastroHabilidadeOpenState = useCallback(
    async (idAvaliacaoHabilidade: number | null, openState: boolean) => {
      if (openState && funcionario) {
        if (idAvaliacaoHabilidade && habilidades) {
          const habilidade = habilidades.find(
            (x) => x.idAvaliacaoHabilidade === idAvaliacaoHabilidade,
          );
          setSelectedHabilidade(habilidade);
          habilidade &&
            (await loadHabilidadeItems(habilidade.idAvaliacaoHabilidade, {
              page: 1,
            }));
        } else {
          await createAvaliacaoHabilidadeUseCase.createAvaliacaoHabilidade(
            funcionario.idFuncionario,
            funcionario.idCargo,
          );

          setSelectedHabilidade(
            createAvaliacaoHabilidadeUseCase.avaliacaoHabilidade,
          );
          setSelectedHabilidadeItems(
            createAvaliacaoHabilidadeUseCase.habilidades,
          );
        }
        await loadHabilidades();
      }
      setOpenCadastroHabilidadeModal(openState);
    },
    [
      funcionario,
      habilidades,
      createAvaliacaoHabilidadeUseCase,
      loadHabilidadeItems,
      loadHabilidades,
    ],
  );

  const handleRelatorioAvaliacaoHabilidadeOpenState = useCallback(
    async (idAvaliacaoHabilidade: number | null) => {
      try {
        setLoading(true);
        if (idAvaliacaoHabilidade) {
          await startReportViewerProcess({
            fetchCallback: async (requiredMimeType) =>
              await getReportAvaliacaoHabilidadeUseCase.getReportAvaliacaoHabilidade(
                requiredMimeType,
                idAvaliacaoHabilidade,
              ),
          });
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setLoading(false);
      }
    },
    [
      getReportAvaliacaoHabilidadeUseCase,
      startReportViewerProcess,
      pushErrorNotification,
    ],
  );

  const handleDeletarHabilidadeOpenState = useCallback(
    (idAvaliacaoHabilidade: number | null, openState: boolean) => {
      if (openState) {
        if (idAvaliacaoHabilidade && habilidades) {
          setSelectedHabilidade(
            habilidades.find(
              (x) => x.idAvaliacaoHabilidade === idAvaliacaoHabilidade,
            ),
          );
        } else {
          setSelectedHabilidade(undefined);
        }
      }
      setOpenDeletarHabilidadeModal(openState);
    },
    [habilidades],
  );

  const handleConfirmarDeletarHabilidade = useCallback(async () => {
    try {
      if (selectedHabilidade && habilidades) {
        setSaving(true);

        await deleteAvaliacaoHabilidadeUseCase.deleteAvaliacaoHabilidade(
          selectedHabilidade.idAvaliacaoHabilidade,
        );

        await loadHabilidades();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar avaliação de habilidade!"),
      );
    } finally {
      setSaving(false);
      setSelectedHabilidade(undefined);
      setOpenDeletarHabilidadeModal(false);
    }
  }, [
    selectedHabilidade,
    habilidades,
    deleteAvaliacaoHabilidadeUseCase,
    loadHabilidades,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleHabilidadeItemsPageChange = useCallback(
    async (page: number) => {
      usePagination.getState().habilidadeItemsSetter.setPage(page + 1);
      if (selectedHabilidade && selectedHabilidade.idAvaliacaoHabilidade) {
        await loadHabilidadeItems(selectedHabilidade.idAvaliacaoHabilidade, {
          page: page + 1,
        });
      } else {
        await loadHabilidadeItems(null, { page: page + 1 });
      }
    },
    [selectedHabilidade, loadHabilidadeItems],
  );

  const handleCadastroHabilidadeItemOpenState = useCallback(
    (idHabilidadeItem: number | null, openState: boolean) => {
      if (openState) {
        if (selectedHabilidadeItems && idHabilidadeItem) {
          const selectedHabilidadeItem = selectedHabilidadeItems.find(
            (x) => x.idHabilidadeItem === idHabilidadeItem,
          );
          setSelectedHabilidadeItem(selectedHabilidadeItem);
        } else {
          setSelectedHabilidadeItem(undefined);
        }
      }
      setOpenCadastroHabilidadeItemModal(openState);
    },
    [selectedHabilidadeItems],
  );

  const handleDeletarHabilidadeItemOpenState = useCallback(
    (idAvaliacaoHabilidadeItem: number | null, openState: boolean) => {
      if (openState) {
        if (idAvaliacaoHabilidadeItem && selectedHabilidadeItems) {
          setSelectedHabilidadeItem(
            selectedHabilidadeItems.find(
              (x) => x.idHabilidadeItem === idAvaliacaoHabilidadeItem,
            ),
          );
        } else {
          setSelectedHabilidadeItem(undefined);
        }
      }
      setOpenDeletarHabilidadeItemModal(openState);
    },
    [selectedHabilidadeItems],
  );

  const handleConfirmarDeletarHabilidadeItem = useCallback(async () => {
    try {
      if (selectedHabilidade) {
        if (selectedHabilidadeItem && selectedHabilidadeItems) {
          setSaving(true);

          await deleteAvaliacaoHabilidadeItemUseCase.deleteAvaliacaoHabilidadeItem(
            selectedHabilidadeItem.idHabilidadeItem,
          );

          setSelectedHabilidade(
            deleteAvaliacaoHabilidadeItemUseCase.avaliacaoHabilidade,
          );
          setSelectedHabilidadeItems(
            deleteAvaliacaoHabilidadeItemUseCase.habilidades,
          );
        }
        await loadHabilidades();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar item de avaliação de habilidade!"),
      );
    } finally {
      setSaving(false);
      setSelectedHabilidadeItem(undefined);
      setOpenDeletarHabilidadeItemModal(false);
    }
  }, [
    selectedHabilidade,
    selectedHabilidadeItem,
    selectedHabilidadeItems,
    deleteAvaliacaoHabilidadeItemUseCase,
    loadHabilidades,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  /**
   * Eventos Controle de Patrimonio
   */

  const handleControlePatrimonioPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().controlePatrimoniosSetter.setPage(page + 1);
        await loadControlePatrimonios({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadControlePatrimonios, pushErrorNotification],
  );

  const handleControlePatrimonioRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination
          .getState()
          .controlePatrimoniosSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().controlePatrimoniosSetter.setPage(1);
        await loadControlePatrimonios({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(
            e,
            "Falha ao buscar relatorio de avaliação treinamento!",
          ),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [loadControlePatrimonios, pushErrorNotification],
  );

  const handleCadastroControlePatrimonioOpenState = useCallback(
    (idControlePatrimonio: number | null, openState: boolean) => {
      if (openState) {
        if (controlePatrimonios && idControlePatrimonio) {
          setSelectedControlePatrimonio(
            controlePatrimonios.find(
              (x) => x.idControlePatrimonio === idControlePatrimonio,
            ),
          );
        } else {
          setSelectedControlePatrimonio(undefined);
        }
      }
      setOpenCadastroControlePatrimonioModal(openState);
    },
    [controlePatrimonios],
  );

  const handleDeletarControlePatrimonioOpenState = useCallback(
    (idControlePatrimonio: number | null, openState: boolean) => {
      if (openState) {
        if (idControlePatrimonio && controlePatrimonios) {
          setSelectedControlePatrimonio(
            controlePatrimonios.find(
              (x) => x.idControlePatrimonio === idControlePatrimonio,
            ),
          );
        } else {
          setSelectedControlePatrimonio(undefined);
        }
      }
      setOpenDeletarControlePatrimonioModal(openState);
    },
    [controlePatrimonios],
  );

  const handleConfirmarDeletarControlePatrimonio = useCallback(async () => {
    try {
      if (selectedControlePatrimonio && controlePatrimonios) {
        setSaving(true);

        await deleteControlePatrimonioUseCase.deleteControlePatrimonio(
          selectedControlePatrimonio.idControlePatrimonio,
        );

        await loadControlePatrimonios();
        pushInfoNotification("Sucesso", "Registro excluido com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao deletar controle de patrimonio!"),
      );
    } finally {
      setSaving(false);
      setSelectedControlePatrimonio(undefined);
      setOpenDeletarControlePatrimonioModal(false);
    }
  }, [
    selectedControlePatrimonio,
    controlePatrimonios,
    deleteControlePatrimonioUseCase,
    loadControlePatrimonios,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  const handleDownloadControlePatrimonio = useCallback(
    async (idControlePatrimonio: number, imageName: string) => {
      try {
        setCustomLoading(true);
        await downloadControlePatrimonioByIdUseCase.downloadControlePatrimonioById(
          idControlePatrimonio,
          imageName,
        );
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao baixar documento!"),
        );
      } finally {
        setCustomLoading(false);
      }
    },
    [
      downloadControlePatrimonioByIdUseCase,
      pushErrorNotification,
      setCustomLoading,
    ],
  );

  const handleOpenChangeHistory = useCallback(
    (idTabela: number | null, tipoTabela: LogTipoTabela | null) => {
      if (idTabela && tipoTabela) {
        changeHistory.handleOpenChangeHistory(idTabela, tipoTabela, false);
      } else {
        if (idFuncionario) {
          changeHistory.handleOpenChangeHistory(
            idFuncionario,
            LogTipoTabela.FUNCIONARIO,
            true,
          );
        }
      }
    },
    [idFuncionario, changeHistory],
  );

  const handleCreateInformacoesGeraisCentroCusto = useCallback(async () => {
    startCentroCustoDrawer(async (form) => {
      try {
        setCustomLoading(true);

        const { idCentroCusto } =
          await createCentroCustoUseCase.createCentroCusto(
            form.status,
            form.codigo,
            form.descricao,
            form.bdi,
            form.bdi2,
            form.numeroCno ?? undefined,
            form.obsCentroCusto ?? undefined,
          );

        await loadCentroCustoDropDown();

        hookForm.setValue("idCentroCusto", idCentroCusto);
        pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao criar centro de custo!"),
        );
      } finally {
        setCustomLoading(false);
      }
    });
  }, [
    hookForm,
    createCentroCustoUseCase,
    loadCentroCustoDropDown,
    startCentroCustoDrawer,
    pushErrorNotification,
    pushInfoNotification,
    setCustomLoading,
  ]);

  const handleCreateSecundarioCentroCusto = useCallback(
    async (callback: (id: number) => void) => {
      startCentroCustoDrawer(async (form) => {
        try {
          setSaving(true);

          const { idCentroCusto } =
            await createCentroCustoUseCase.createCentroCusto(
              form.status,
              form.codigo,
              form.descricao,
              form.bdi,
              form.bdi2,
              form.numeroCno ?? undefined,
              form.obsCentroCusto ?? undefined,
            );

          await loadCentroCustoDropDown();

          callback(idCentroCusto);
          pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
        } catch (e: unknown) {
          pushErrorNotification(
            "Erro",
            processError(e, "Falha ao criar centro de custo!"),
          );
        } finally {
          setSaving(false);
        }
      });
    },
    [
      createCentroCustoUseCase,
      loadCentroCustoDropDown,
      startCentroCustoDrawer,
      pushErrorNotification,
      pushInfoNotification,
    ],
  );

  const handleCreateMotivoDemissao = useCallback(async () => {
    startMotivoDemissaoDrawer(async (form) => {
      try {
        setSaving(true);

        const idMotivoDemissao =
          await createMotivoDemissaoUseCase.createMotivoDemissao(
            form.ativo,
            form.descricaoMotivo,
          );

        await loadMotivoDemissaoDropDown();

        hookForm.setValue("demissaoIdDemissao", idMotivoDemissao);

        pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao criar centro de custo!"),
        );
      } finally {
        setSaving(false);
      }
    });
  }, [
    hookForm,
    createMotivoDemissaoUseCase,
    startMotivoDemissaoDrawer,
    loadMotivoDemissaoDropDown,
    pushErrorNotification,
    pushInfoNotification,
  ]);

  //#region  biometriaFacial

  const handleBiometriaFacialPageChange = useCallback(
    async (page: number) => {
      try {
        usePagination.getState().biometriaFacialSetter.setPage(page + 1);
        // await loadBiometriaFacial({ page: page + 1 });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar biometria facial!"),
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [pushErrorNotification],
  );
  const handleBiometriaFacialRowsPerPageChange = useCallback(
    async (rowsPerPage: number) => {
      try {
        usePagination
          .getState()
          .biometriaFacialSetter.setRowsPerPage(rowsPerPage);
        usePagination.getState().biometriaFacialSetter.setPage(1);
        // await loadBiometriaFacial({ page: 1, rowsPerPage });
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao buscar biometria facial!"),
          { isAutoFinish: true },
        );
      } finally {
        setSelectedFuncionarioTreinamento(undefined);
        setOpenRelatorioFuncionarioTreinamentoModal(false);
      }
    },
    [pushErrorNotification],
  );
  const handleCadastroBiometriaFacialOpenState = useCallback(
    (idBiometriaFacial: number | null, openState: boolean) => {
      if (openState) {
        if (biometriaFacial && idBiometriaFacial) {
          setSelectedBiometriaFacial(
            biometriaFacial.find(
              (x) => x.IdBiometriaFacial === idBiometriaFacial,
            ),
          );
        } else {
          setSelectedBiometriaFacial(undefined);
        }
      }
      setOpenCadastroBiometriaFacialModal(openState);
    },
    [biometriaFacial],
  );

  const handleDeletarBiometriaFacialOpenState = useCallback(
    (idBiometriaFacial: number | null, openState: boolean) => {
      if (openState) {
        if (idBiometriaFacial && biometriaFacial) {
          setSelectedBiometriaFacial(
            biometriaFacial.find(
              (x) => x.IdBiometriaFacial === idBiometriaFacial,
            ),
          );
        } else {
          setSelectedBiometriaFacial(undefined);
        }
      }
      setOpenInativarBiometriaModal(openState);
    },
    [biometriaFacial],
  );

  const handleSubmitBiometriaFacial = useCallback(
    async (form: BiometriaFacialForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (!form.biometria) {
              pushErrorNotification(
                "Erro",
                "É necessário capturar a biometria antes de salvar.",
              );
              return;
            }
            if (!form.idTermoEpi) {
              pushErrorNotification(
                "Erro",
                "Selecione e aceite um termo antes de salvar.",
              );
              return;
            }
            await createBiometriaFacialFuncionarioUseCase.createBiometriaFacialFuncionario(
              funcionario?.idFuncionario ?? 0,
              form.data,
              form.hora,
              form.biometria,
              form.idTermoEpi,
            );

            await loadBiometriaFacial({
              idFuncionario: funcionario?.idFuncionario ?? 0,
            });

            pushInfoNotification(
              "Sucesso",
              "Biometria registrada e termo assinado com sucesso!",
            );
          }
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
          { isAutoFinish: true },
        );
      } finally {
        setSaving(false);
        setOpenCadastroBiometriaFacialModal(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      loadBiometriaFacial,
      pushInfoNotification,
      createBiometriaFacialFuncionarioUseCase, // 👈 Atualizado na lista de dependências
      pushErrorNotification,
    ],
  );

  const handleRegisterBiometriaFacial = useCallback(
    async (form: BiometriaFacialForm) => {
      try {
        if (!saving && !loading) {
          setSaving(true);

          if (funcionario) {
            if (form.biometria) {
              const response =
                await createBiometriaFacialUseCase.createBiometriaFacial(
                  form.idFuncionario ?? 0,
                  form.biometria,
                );
              setGryfoRequestId(response);
              return response;
            }
          }
          await loadControlePatrimonios();
          pushInfoNotification("Sucesso", "Registro salvo com sucesso!");
        }
      } catch (e: unknown) {
        pushErrorNotification(
          "Erro",
          processError(e, "Falha ao salvar documento!"),
          { isAutoFinish: true },
        );
      } finally {
        setSaving(false);
      }
    },
    [
      saving,
      loading,
      funcionario,
      loadControlePatrimonios,
      pushInfoNotification,
      createBiometriaFacialUseCase,
      pushErrorNotification,
    ],
  );

  const handleConfirmarInativarBiometria = useCallback(async () => {
    try {
      if (selectedBiometriaFacial?.IdFuncionario) {
        setSaving(true);

        await inativarBiometriaFacialUseCase.inativarBiometriaFacial(
          selectedBiometriaFacial.IdFuncionario,
        );

        await loadBiometriaFacial({
          idFuncionario: funcionario?.idFuncionario ?? 0,
        });
        pushInfoNotification("Sucesso", "Registro inativado com sucesso!");
      }
    } catch (e: unknown) {
      pushErrorNotification(
        "Erro",
        processError(e, "Falha ao inativar biometria facial!"),
        { isAutoFinish: true },
      );
    } finally {
      setSaving(false);
      setSelectedBiometriaFacial(undefined);
      setOpenInativarBiometriaModal(false);
    }
  }, [
    selectedBiometriaFacial,
    inativarBiometriaFacialUseCase,
    loadBiometriaFacial,
    funcionario?.idFuncionario,
    pushInfoNotification,
    pushErrorNotification,
  ]);

  const handleActionVisualize = useCallback(
    async (idBiometriaFacial: number) => {
      if (biometriaFacial && biometriaFacial.length > 0) {
        const biometria = biometriaFacial.find(
          (x) => x.IdBiometriaFacial === idBiometriaFacial,
        );
        if (biometria) {
          try {
            setLoading(true);
            const url =
              await getBiometriaFacialVisualizarUseCase.getBiometriaFacialVisualizar(
                biometria.IdBiometriaFacial,
                "",
              );
            setModalImagemOpen(true);
            setImagemUrl(url);
            setSelectedBiometriaFacial(biometria);
          } catch (e: unknown) {
            pushErrorNotification(
              "Erro",
              processError(e, "Falha ao buscar imagens!"),
              { isAutoFinish: true },
            );
          } finally {
            setLoading(false);
          }
        }
      }
    },
    [
      biometriaFacial,
      getBiometriaFacialVisualizarUseCase,
      pushErrorNotification,
    ],
  );

  //#endregion

  const handleActionAuditoria = useCallback(
    async (AuditId: string) => {
      if (AuditId && biometriaFacial && termoEpiLista) {
        try {
          const biometria = biometriaFacial.find((x) => x.AuditId === AuditId);
          const termo = termoEpiLista.find(
            (x) => x.idTermoEPI === biometria?.IdTermoEPI,
          );
          setLoading(true);
          const url = await getBiometriaAuditoriaUseCase.getBiometriaAuditoria(
            0,
            AuditId,
          );
          setSelectedTermo(termo);
          setImagemUrl(url);
          setSelectedGryfoAudit(url);
          setModalGryfoAudit(true);
        } catch (e: unknown) {
          pushWarnNotification(
            "Alerta",
            processError(e, "Falha ao validar!")[0],
          );
        } finally {
          setLoading(false);
        }
      }
    },
    [
      biometriaFacial,
      getBiometriaAuditoriaUseCase,
      pushWarnNotification,
      termoEpiLista,
    ],
  );
  const handleCloseModalGryfoAudit = useCallback(() => {
    setModalGryfoAudit(false);
    if (imagemUrl) {
      window.URL.revokeObjectURL(imagemUrl);
      setImagemUrl(null);
    }
  }, [imagemUrl]);

  const handleCloseModalImagem = useCallback(() => {
    setModalImagemOpen(false);
    if (imagemUrl) {
      window.URL.revokeObjectURL(imagemUrl);
      setImagemUrl(null);
    }
  }, [imagemUrl]);
  const handleJobWaiterOpenState = useCallback((openState: boolean) => {
    setOpenJobWaiterModel(openState);
  }, [
  ]);

  const handleUpdateJobStatus = useCallback(async (callback: (response: JobStatusResponse) => void) => {
    if (jobId) {
      try {
        callback(await getJobStatusUseCase.getJobStatus(jobId));
      } catch (e: unknown) {
        pushErrorNotification('Erro', processError(e, 'Falha ao buscar status da tarefa!'));
      }
    }
  }, [
    jobId,
    getJobStatusUseCase,
    pushErrorNotification,
  ]);

  const handleJobStatusError = useCallback((message: string) => {
    pushErrorNotification('Erro', message);
  }, [
    pushErrorNotification,
  ]);

  return {
    filters,
    pagination,
    loading,
    saving,
    isCreated,
    status,
    errorMessage,
    currentTab,
    idFuncionario,
    funcionario: funcionario ?? null,
    fileUpload: fileUpload ?? null,

    hookForm,

    selectedCentroCustoSecundario,
    selectedDependente,
    selectedEvento,
    selectedFerias,
    selectedAfastamento,

    selectedFuncionarioTreinamento,
    selectedDocumento,
    selectedHabilidade,

    selectedHabilidadeItem,
    selectedHabilidadeItems: selectedHabilidadeItems ?? [],

    selectedControlePatrimonio,

    openCadastroCentroCustoSecundarioModal,
    openCadastroDependenteModal,
    openCadastroEventoModal,
    openCadastroFeriasModal,
    openCadastroAfastamentoModal,
    openJobWaiterModel,

    openDeletarDependenteModal,
    openDeletarEventoModal,
    openDeletarFeriasModal,
    openDeletarAfastamentoModal,
    openDeletarCentroCustoSecundarioModal,

    openCadastroDocumentoModal,
    openDeletarDocumentoModal,
    openDeletarAllDocumentosModal,

    openCadastroFuncionarioTreinamentoModal,
    openAvaliarFuncionarioTreinamentoModal,
    openDeletarFuncionarioTreinamentoModal,
    openDeletarFuncionarioTreinamentosLoteModal,
    openRelatorioFuncionarioTreinamentoModal,

    openCadastroHabilidadeModal,
    openDeletarHabilidadeModal,

    openCadastroHabilidadeItemModal,
    openDeletarHabilidadeItemModal,

    openCadastroControlePatrimonioModal,
    openDeletarControlePatrimonioModal,

    changeHistory,

    reportViewerState,
    centroCustoDrawerState,
    motivoDemissaoDrawerState,

    centroCustoSecundarios: centroCustoSecundarios ?? [],
    dependentes: dependentes ?? [],
    eventos: eventos ?? [],
    ferias: ferias ?? [],
    afastamentos: afastamentos ?? [],

    documentos: documentos ?? [],
    documentosEntregues: documentosEntregues ?? [],

    funcionarioTreinamentos: funcionarioTreinamentos ?? [],

    habilidades: habilidades ?? [],

    biometriaFacial: biometriaFacial ?? [],
    controlePatrimonios: controlePatrimonios ?? [],

    openCadastroBiometriaFacialModal,
    selectedBiometriaFacial,
    openInativarBiometriaModal,
    deleteTermoModal,
    selectedTermo,
    termoModal,
    termoEpiLista,
    gryfoAuditOpen,
    imagemUrl,
    selectedGryfoAudit,
    modalImagemOpen,
    handleSubmitBiometriaFacial,
    handleReloadPage,
    handleRelatorio,
    handleNewFuncionario,
    handleExcluirFuncionario,
    handleTabChange,
    handleBack,
    handleCancel,
    handleLoadCep,
    handleStartFileUpload,
    handleDeleteFileUpload,
    handleSubmit: hookForm.handleSubmit(handleSubmitFuncionario),
    handleSubmitFuncionario,
    handleSubmitCentroCustoSecundario,
    handleSubmitDependente,
    handleSubmitEvento,
    handleSubmitFerias,
    handleSubmitAfastamento,
    handleSubmitDocumento,
    handleSubmitTreinamento,
    handleSubmitAvaliarTreinamento,
    handleSubmitAvaliarHabilidade,
    handleSubmitAvaliarHabilidadeItem,
    handleSubmitControlePatrimonio,
    handleSubmitRelatorioFuncionarioTreinamento,

    handleCadastroFuncionarioTreinamentoOpenState,
    handleAvaliarFuncionarioTreinamentoOpenState,
    handleAvaliarLoteTreinamentoOpenState,
    handleEditarFuncionarioTreinamento,
    handleFuncionarioTreinamentosPageChange,
    handleFuncionarioTreinamentosRowsPerPageChange,
    handleDeletarFuncionarioTreinamentoOpenState,
    handleDeletarTreinamentosLoteOpenState,
    handleConfirmarDeletarFuncionarioTreinamento,
    handleConfirmarDeletarFuncionarioTreinamentosLote,
    handleRelatorioFuncionarioTreinamentoOpenState,
    handleCertificadoFuncionarioTreinamentoSubmit,
    handleCadastroCentroCustoSecundarioOpenState,
    handleCadastroDependenteOpenState,
    handleCadastroEventoOpenState,
    handleCadastroFeriasOpenState,
    handleCadastroAfastamentoOpenState,
    handleDeletarCentroCustoSecundarioOpenState,
    handleDeletarDependenteOpenState,
    handleDeletarEventoOpenState,
    handleDeletarFeriasOpenState,
    handleDeletarAfastamentoOpenState,
    handleConfirmarDeletarCentroCustoSecundario,
    handleConfirmarDeletarDependente,
    handleConfirmarDeletarEvento,
    handleConfirmarDeletarFerias,
    handleConfirmarDeletarAfastamento,
    handleCentroCustoSecundarioPageChange,
    handleCentroCustoSecundarioRowsPerPageChange,
    handleDependentesPageChange,
    handleDependentesRowsPerPageChange,
    handleEventosPageChange,
    handleEventosRowsPerPageChange,
    handleFeriasPageChange,
    handleFeriasRowsPerPageChange,
    handleAfastamentoPageChange,
    handleAfastamentoRowsPerPageChange,

    handleDocumentosPageChange,
    handleDocumentosRowsPerPageChange,
    handleDocumentosEntreguesPageChange,
    handleDocumentosEntreguesRowsPerPageChange,
    handleCadastroDocumentoOpenState,
    handleDeletarDocumentoOpenState,
    handleConfirmarDeletarDocumento,
    handleDeletarAllDocumentosOpenState,
    handleConfirmarDeletarAllDocumentos,
    handleDownloadDocumento,
    handleFuncionarioGetAllDocumentos,

    handleHabilidadesPageChange,
    handleHabilidadesRowsPerPageChange,
    handleCadastroHabilidadeOpenState,
    handleRelatorioAvaliacaoHabilidadeOpenState,
    handleDeletarHabilidadeOpenState,
    handleConfirmarDeletarHabilidade,

    handleHabilidadeItemsPageChange,

    handleCadastroHabilidadeItemOpenState,
    handleDeletarHabilidadeItemOpenState,
    handleConfirmarDeletarHabilidadeItem,

    handleControlePatrimonioPageChange,
    handleControlePatrimonioRowsPerPageChange,

    handleCadastroControlePatrimonioOpenState,
    handleDeletarControlePatrimonioOpenState,
    handleConfirmarDeletarControlePatrimonio,
    handleDownloadControlePatrimonio,

    handleOpenChangeHistory,

    handleCreateInformacoesGeraisCentroCusto,
    handleCreateSecundarioCentroCusto,
    handleCreateMotivoDemissao,

    handleBiometriaFacialPageChange,
    handleBiometriaFacialRowsPerPageChange,
    handleCadastroBiometriaFacialOpenState,
    handleDeletarBiometriaFacialOpenState,
    handleRegisterBiometriaFacial,
    handleConfirmarInativarBiometria,
    handleActionVisualize,
    handleCloseModalGryfoAudit,
    handleCloseModalImagem,
    handleActionAuditoria,
    handleJobWaiterOpenState,
    handleUpdateJobStatus,
    handleJobStatusError,
  };
};
